import { LandingPageTypes } from "@enums/landing-page-types";
import { MessagingTemplateTypes } from "@enums/messaging-template-types";
import { PolicyDecisionActionTypes } from "@iddataweb/idw-common-ui/enums";

export const resources = {
    charts: {
        dashboardVerificationCounts: {
            labels: {
                approved: "Approved",
                denied: "Denied",
                obligations: "Obligations",
                noDecision: "No Decision"
            },
            legend: {
                title: "Transaction Status"
            },
            xAxis: {
                titles: {
                    day: "Day",
                    hour: "Hour"
                }
            }
        },
        verificationTransactionsSummary: {
            labels: {
                approved: "Approved",
                denied: "Denied",
                obligations: "Obligations",
                noDecision: "No Decision"
            }
        },
        workflowReportCompletionRates: {
            title: "Summary",
            labels: {
                complete: "Flow Complete",
                incomplete: "Flow Incomplete"
            }
        },
        workflowReportCompletionRatesOverTime: {
            title: "Timeline",
            labels: {
                complete: "Flow Complete",
                incomplete: "Flow Incomplete"
            }
        },
        workflowReportPassRates: {
            title: "Summary",
            labels: {
                denied: "Denied"
            }
        },
        workflowReportPassRatesOverTime: {
            title: "Timeline",
            labels: {
                denied: "Denied Unique Users"
            }
        },
        workflowReportVolumesByAppID: {
            title: "Volumes by App ID",
        },
        workflowVolumesByCountry: {
            title: "Volumes By Country",
        }
    },
    common: {
        buttons: {
            back: {
                label: "Back"
            },
            cancel: {
                label: "Cancel"
            },
            chooseFile: {
                label: "Choose File"
            },
            clear: {
                label: "Clear"
            },
            close: {
                label: "Close"
            },
            continue: {
                label: "Continue"
            },
            copy: {
                label: "Copy"
            },
            create: {
                label: "Create"
            },
            delete: {
                label: "Delete"
            },
            edit: {
                label: "Edit"
            },
            export: {
                label: "Export"
            },
            exportToCSV: {
                label: "Export to CSV"
            },
            goBack: {
                label: "Go Back"
            },
            load: {
                label: "Load"
            },
            invite: {
                label: "Invite"
            },
            refresh: {
                label: "Refresh"
            },
            save: {
                label: "Save"
            },
            search: {
                label: "Search"
            },
            update: {
                label: "Update"
            },
            view: {
                label: "View"
            },
            viewAll: {
                label: "View All"
            },
            proceed: {
                label: "Proceed"
            }
        },
        labels: {
            status: "Status"
        },
        containers: {
            workflowVisualization: {
                sections: {
                    menu: {
                        openServiceDetails: {
                            label: "Open Service Details"
                        },
                        viewPolicyDecision: {
                            label: "View Policy Decision"
                        },
                        setAsPrimaryService: {
                            label: "Set as Primary Service"
                        },
                        archiveService: {
                            label: "Archive Service",
                            primaryServiceTooltip: "This is the primary service of the workflow. It cannot be archived."
                        }
                    },
                    serviceDetails: {
                        header: "Service Details",
                        inputs: {
                            name: {
                                label: "Service Name"
                            },
                            policyConfigDescription: {
                                label: "Policy Config Description"
                            }
                        },
                        sections: {
                            attributes: {
                                header: "Attributes",
                                noAttributesMessage: "No attributes have been added to this service"
                            },
                            properties: {
                                header: "Properties",
                                noPropertiesMessage: "No properties have been added to this service"
                            },
                            policyConfig: {
                                header: "Policy Configuration",
                                inputs: {
                                    defaultAction: {
                                        label: "Default Action"
                                    },
                                    stepUpApiKey: {
                                        label: "Default Step Up API Key"
                                    }
                                }
                            }
                        },
                        buttons: {
                            viewPolicyDetails: {
                                label: "View Policy Details"
                            }
                        }
                    }
                }
            }
        },
        dropdownItems: {
            view: {
                label: "View"
            },
            edit: {
                label: "Edit Change Request"
            },
            switchToEdit: {
                label: "Switch to Edit Mode"
            },
            switchToView: {
                label: "Switch to View Mode"
            },
            tryNow: {
                label: "Try Now"
            },
            copyLink: {
                label: "Copy Link"
            },
            sendEmail: {
                label: "Send Email With Link"
            },
            deployChangesNow: {
                label: "Deploy Changes Now",
                unsavedChangesTooltip: "You have unsaved changes. Save them or revert them to enable the ability to Deploy Now",
                validationErrorsTooltip: "There are validation errors. Fix them to enable the ability to Deploy Now"
            },
            createModifyChangeRequest: {
                label: "Start Change request"
            },
            submitChangeRequestForReview: {
                label: "Submit Change Request for Review",
                unsavedChangesTooltip: "You have unsaved changes. Save them or revert them to enable the ability to Submit for Review",
                validationErrorsTooltip: "There are validation errors. Fix them to enable the ability to Submit for Review"
            },
            unsubmitChangeRequest: {
                label: "Un-submit Change Request"
            },
            reviewChangeRequest: {
                label: "Review Change Request"
            },
            approveChangeRequest: {
                label: "Approve Change Request"
            },
            rejectChangeRequest: {
                label: "Reject Change Request"
            },
            cancelChangeRequest: {
                label: "Cancel Change Request"
            },
            reports: {
                label: "Reports"
            },
            execution: {
                label: "Execution"
            },
            configuration: {
                label: "Configuration"
            }
        },
        errors: {
            invalidURL: "Invalid URL - URLs cannot contain spaces"
        },
        inputs: {
            attributeLabel: {
                label: "Label",
                placeholder: "Label"
            },
            attributeType: {
                label: "Attribute Type"
            },
            country: {
                label: "Country"
            },
            emailTemplate: {
                label: "Email Template"
            },
            fileInput: {
                placeholder: "No file chosen"
            },
            identityProvider: {
                label: "Identity Provider"
            },
            loginIdp: {
                label: "Login IDP"
            },
            operationType: {
                label: "Operation Type"
            },
            organization: {
                label: "Organization"
            },
            redirectTo: {
                label: "Redirect To"
            },
            relyingParty: {
                label: "Relying Party"
            },
            role: {
                label: "Role"
            },
            service: {
                label: "Service"
            },
            status: {
                label: "Status"
            },
            template: {
                label: "Template"
            },
            workflowTemplate: {
                label: "Workflow Template"
            },
            workflow: {
                label: "Workflow",
                noWorkflowFoundErrorMessage: "No workflows exist for the selected Relying Party",
                createWorkflowButtonText: "Create Workflow",
                createWorkflowButtonDisabledText: "You have reached the maximum number of workflows allowed for your current subscription tier. To continue adding more workflows, please delete unused workflows, upgrade your subscription, or contact support for further assistance."
            }
        },
        uploadInProgress: "Upload in progress...",
        loadingIndicatorText: "Retrieving Data",
        archived: "archived",
        active: "active",
        more: "More",
        learnMore: "Learn More",
        documentation: "Documentation",
        expand: "Expand",
        collapse: "Collapse",
        inactive: "inactive",
        notAvailable: "N/A",
        notFound: "--",
        noDataToDisplay: "No data to display",
        allRequiredFields: "All fields are required",
        requiredField: "This field is required",
        unknown: "Unknown",
        timeRanges: {
            today: "Today",
            pastMinute: "Past minute",
            pastThreeMinutes: "Past 3 minutes",
            pastFiveMinutes: "Past 5 minutes",
            pastTenMinutes: "Past 10 minutes",
            pastFifteenMinutes: "Past 15 minutes",
            pastThirtyMinutes: "Past 30 minutes",
            pastOneHour: "Past 1 hour",
            pastThreeHours: "Past 3 hours",
            pastSixHours: "Past 6 hours",
            pastTwelveHours: "Past 12 hours",
            pastTwentyFourHours: "Past 24 hours",
            pastThreeDays: "Past 3 days",
            pastSevenDays: "Past 7 days",
            pastFourteenDays: "Past 14 days",
            pastThirtyDays: "Past 30 days",
            pastNinetyDays: "Past 90 days",
            currentMonth: "Current Month",
            lastMonth: "Last Month",
            currentQuarter: "Current Quarter",
            lastQuarter: "Last Quarter",
            currentYear: "Current Year",
            lastYear: "Last Year",
            custom: "Custom"
        },
        searchForm: {
            description: "Use the parameters below to customize and load your report",
            showFilters: "Show Filters",
            filters: {
                customizeBy: {
                    label: "Customize By:"
                },
                startDate: {
                    label: "Start Date"
                },
                endDate: {
                    label: "End Date"
                },
                timeRange: {
                    label: "Time Range"
                },
                organization: {
                    label: "Organization"
                },
                relyingParty: {
                    label: "Relying Party",
                    noOptionsMessage: "No Relying Parties Available"
                },
                relyingParties: {
                    label: "Relying Parties",
                    noOptionsMessage: "No Relying Parties Available"
                },
                verificationService: {
                    label: "Verification Service",
                    noOptionsMessage: "No Services Available"
                },
                verificationServices: {
                    label: "Verification Services",
                    noOptionsMessage: "No Services Available"
                },
                workflow: {
                    label: "Workflow",
                    noOptionsMessage: "No Workflows Available"
                },
                workflows: {
                    label: "Workflows",
                    noOptionsMessage: "No Workflows Available"
                },
                organizations: {
                    label: "Organizations"
                },
                policyDecisions: {
                    label: "Policy Decisions"
                },
                serviceOfferings: {
                    label: "Attribute Providers"
                },
                countries: {
                    htmlLabel: 'Cou&#8205;ntries'
                }
            }
        }
    },
    exports: {
        alertEvents: {
            columns: {
                dateTriggered: {
                    header: "Date Triggered"
                },
                alert: {
                    header: "Alert"
                },
                organization: {
                    header: "Organization"
                },
                workflow: {
                    header: "Workflow"
                },
                service: {
                    header: "Service"
                },
                credential: {
                    header: "Credential"
                },
                cause: {
                    header: "Cause"
                }
            }
        },
        fraudReport: {
            columns: {
                date: {
                    header: "Date"
                },
                asi: {
                    header: "ASI"
                },
                credential: {
                    header: "Credential"
                },
                mbun: {
                    header: "MBUN"
                },
                assertion: {
                    header: "Assertion"
                },
                claimStatus: {
                    header: "Claim Status"
                },
                riskLevel: {
                    header: "Risk Level"
                },
                finalPolicyDecision: {
                    header: "Final Policy Decision"
                },
                relyingParty: {
                    header: "Relying Party"
                },
                verificationService: {
                    header: "Verification Service"
                }
            }
        },
        verificationTransactionDetailsClaimsAssertions: {
            columns: {
                date: {
                    header: "Date"
                },
                verificationService: {
                    header: "Verification Service"
                },
                apiKey: {
                    header: "API Key"
                },
                serviceOffering: {
                    header: "Attribute Provider"
                },
                claim: {
                    header: "Claim"
                },
                claimStatus: {
                    header: "Claim Status"
                }
            }
        },
        verificationTransactionDetailsPolicyDecisions: {
            columns: {
                date: {
                    header: "Date"
                },
                verificationService: {
                    header: "Verification Service"
                },
                apiKey: {
                    header: "API Key"
                },
                policy: {
                    header: "Policy"
                },
                decision: {
                    header: "Decision"
                },
                stepUpVerificationService: {
                    header: "Step Up Verification Service"
                },
                stepUpApiKey: {
                    header: "Step Up API Key"
                },
                decisionDetails: {
                    header: "Decision Details"
                }
            }
        },
        verificationTransactionDetailsScores: {
            columns: {
                date: {
                    header: "Date"
                },
                scoreType: {
                    header: "Score Type"
                },
                score: {
                    header: "Score"
                }
            }
        },
        verificationTransactionDetailsTransactionEvents: {
            columns: {
                date: {
                    header: "Date"
                },
                verificationService: {
                    header: "Verification Service"
                },
                apiKey: {
                    header: "API Key"
                },
                transactionEventDescription: {
                    header: "Transaction Event Description"
                },
                details: {
                    header: "Details"
                },
            }
        },
        verificationTransactions: {
            columns: {
                transactionId: {
                    header: "Transaction ID"
                },
                date: {
                    header: "Date"
                },
                relyingParty: {
                    header: "Relying Party"
                },
                verificationService: {
                    header: "Verification Service"
                },
                credential: {
                    header: "Credential"
                },
                score: {
                    header: "Score"
                },
                policyDecision: {
                    header: "Policy Decision"
                },
                appId: {
                    header: "App ID"
                }
            }
        }
    },
    modals: {
        addAttributeLabel: {
            title: "Add Attribute Label"
        },
        addBackupService: {
            title: "Add Backup Service",
            buttons: {
                addBackupService: {
                    label: "Add Backup Service"
                }
            }
        },
        addLandingPage: {
            title: (landingPageType: LandingPageTypes) => `Add ${landingPageType}`,
            inputs: {
                staticLandingPageType: {
                    label: "Static Landing Page Type",
                    validation: {
                        noneAvailable: "You have already added all of the available Static Landing Pages"
                    }
                },
                landingPage: {
                    label: "Landing Page Name",
                    validation: {
                        empty: "Landing Page Name cannot be blank",
                        noSpaces: "Landing Page Name cannot include spaces"
                    }
                },
                redirectUrl: {
                    label: "Redirect URL",
                    validation: {
                        empty: "Redirect URL cannot be blank",
                        noSpaces: "Redirect URL cannot include spaces",
                        duplicated: "This redirect URL already exists",
                        customRedirectNotAllowed: `URLs that contain "/display/" are reserved for internal Custom URLs. Please choose a different URL.`
                    }
                }
            }
        },
        addMessagingTemplateLanguage: {
            title: "Add Messaging Template Language",
            inputs: {
                language: {
                    label: "Language"
                }
            }
        },
        addEmailTemplateLanguage: {
            title: "Add Email Template Language",
            inputs: {
                language: {
                    label: "Language"
                }
            }
        },
        addMessagingTemplate: {
            title: "Add Messaging Template",
            buttons: {
                nextToContent: {
                    label: "Next: Set Content"
                },
                nextToVariables: {
                    label: "Next: Set Variables"
                },
                addMessagingTemplate: {
                    label: "Add Messaging Template"
                }
            },
            inputs: {
                iWantTo: {
                    label: "I want to"
                },
                templateAvailabilityLevel: {
                    label: "Template Availability Level"
                },
                name: {
                    label: "Template Name",
                    placeholder: "Enter a name for the template"
                },
                template: {
                    label: "Template Content",
                    placeholder: "Content of the template"
                },
                type: {
                    label: "Template Type"
                }
            }
        },
        addEmailTemplate: {
            title: "Add Email Template",
            buttons: {
                nextToContent: {
                    label: "Next: Set Content"
                },
                nextToVariables: {
                    label: "Next: Set Variables"
                },
                addEmailTemplate: {
                    label: "Add Email Template"
                }
            },
            inputs: {
                iWantTo: {
                    label: "I want to"
                },
                templateAvailabilityLevel: {
                    label: "Template Availability Level"
                },
                name: {
                    label: "Template Name",
                    placeholder: "Enter a name for the template"
                },
                sender: {
                    label: "Sender",
                    placeholder: "Enter the sender's email address"
                },
                template: {
                    label: "Template Content",
                    placeholder: "Content of the template"
                },
                type: {
                    label: "Template Type"
                }
            }
        },
        addRpServiceConfigurationAttribute: {
            title: "Add Attribute",
            buttons: {
                addAttribute: {
                    label: "Add Attribute"
                }
            },
            inputs: {
                attribute: {
                    label: "Attribute"
                },
                label: {
                    label: "Label"
                }
            }
        },
        addRpServiceConfigurationIdentityProvider: {
            title: "Add Identity Provider",
            buttons: {
                addIdentityProvider: {
                    label: "Add Identity Provider"
                }
            },
            inputs: {
                identityProvider: {
                    label: "Identity Provider"
                }
            }
        },
        addRpServiceConfigurationPolicyConfigDecision: {
            title: "Add Rule",
            buttons: {
                addRule: {
                    label: "Add Rule"
                }
            },
            inputs: {
                decisionType: {
                    label: "Then:"
                },
                stepUpTo: {
                    label: "Step up to"
                }
            }
        },
        addRpServiceConfigurationProperty: {
            title: "Add Property",
            buttons: {
                addProperty: {
                    label: "Add Property"
                }
            },
            inputs: {
                property: {
                    label: "Property"
                },
                value: {
                    label: "Value"
                }
            }
        },
        addRpServiceConfigurationServiceOffering: {
            title: "Add Attribute Provider",
            buttons: {
                addService: {
                    label: "Add Attribute Provider"
                }
            },
            inputs: {
                service: {
                    label: "Attribute Provider"
                },
                dataSource: {
                    label: "Data Source"
                }
            }
        },
        addRpServiceConfigurationServiceOfferingAssertion: {
            title: "Add Assertion",
            buttons: {
                addAssertion: {
                    label: "Add Assertion"
                }
            },
            labels: {
                description: "Description"
            },
            inputs: {
                assertion: {
                    label: "Assertion"
                }
            }
        },
        addIdentityProvider: {
            title: "Add Identity Provider",
            description: `This action will create a new Change Request to ADD an IDP Configuration.
            When you have finished configuring the IDP Configuration, SUBMIT the Change Request for review to continue the process.
            You may also cancel the Change Request at any time prior to deployment using the CANCEL option.`,
            descriptionForOrgDetails: `This action will create a new Change Request to ADD an IDP Configuration and modify it.
            When you have finished configuring the IDP Configuration, you can click on save to deploy it.`,
            buttons: {
                useBlank: {
                    label: "Create New Identity Provider"
                },
                useCopy: {
                    label: "Copy IDP Configuration"
                },
                useImport: {
                    label: "Import IDP Configuration"
                }
            },
            inputs: {
                file: {
                    label: "File"
                },
                iWantTo: {
                    label: "I want to"
                }
            }
        },
        addOrganization: {
            title: "Create New Organization",
            description: `Fill in the new Organization details below and click "Save" to create the Organization.`,
            warnings: {
                retryCreateOrganization: {
                    label: "An error occurred while creating the Organization. To retry, click Save again."
                },
                retryConfigureLogin: {
                    label: "An error occurred while configuring a corporate login for the new Organization. To retry this step, click Save again."
                },
                retryCreateUser: {
                    label: "An error occurred while creating the first user in the new Organization. To retry this step, click Save again."
                }
            },
            inputs: {
                organizationName: {
                    label: "Organization Name",
                    placeholder: "Enter the organization name"
                },
                customerSupportTier: {
                    label: "Tier",
                },
                createFirstUser: {
                    label: "Create First User",
                    tooltip: "Automatically create the first user for this organization in AXN Admin. Useful for creating an Admin API service account or provisioning a federated user without requiring them to complete a signup process."
                },
                firstName: {
                    label: "First Name",
                    placeholder: "Enter the user's first name"
                },
                lastName: {
                    label: "Last Name",
                    placeholder: "Enter the user's last name"
                },
                email: {
                    label: "Email Address",
                    placeholder: "Enter the user's email address"
                }
            }
        },
        addOrganizationUser: {
            title: "New Invitation",
            noRelyingPartyRolesError: "You must add at least one Relying Party Role.",
            inputs: {
                firstName: {
                    label: "First Name",
                    placeholder: "Enter the user's first name"
                },
                lastName: {
                    label: "Last Name",
                    placeholder: "Enter the user's last name"
                },
                email: {
                    label: "Email",
                    placeholder: "user@example.com"
                },
                apiUserName: {
                    label: "API Username",
                    placeholder: "Enter a username"
                },
                apiPassword: {
                    label: "API Password",
                    placeholder: "Enter a password"
                },
                invite: {
                    label: "Invite a new user to:"
                },
                iWantTo: {
                    label: "I want to"
                },
                organizationName: {
                    label: "Organization Name",
                    placeholder: "Enter the organization name"
                },
                roleType: {
                    label: "Role Type"
                },
                role: {
                    label: "Role"
                },
                relyingParty: {
                    label: "Relying Party",
                    required: "Please select a relying party"
                }
            },
            invitationTypeOptions: {
                create: {
                    label: "Create a New Organization"
                },
                join: {
                    label: "Join an Existing Organization"
                }
            }
        },
        addRelyingParty: {
            title: "Create New Relying Party",
            description: `Fill in the new Relying Party details below and click "Save" to create the Relying Party.`,
            inputs: {
                name: {
                    label: "Name",
                    placeholder: "Enter the relying party name"
                }
            }
        },
        addRelyingPartyRole: {
            title: "Add Relying Party Role for User"
        },
        addSecurityRule: {
            title: "Add Security Rule",
            inputs: {
                id: {
                    label: "ID",
                    placeholder: "ID"
                },
                className: {
                    label: "Class Name",
                    placeholder: "Class Name"
                },
                pathText: {
                    label: "Path Text",
                    placeholder: "Path Text"
                },
                ruleName: {
                    label: "Rule Name",
                    placeholder: "Rule Name"
                },
                rule: {
                    label: "Rule",
                    placeholder: "Rule"
                }
            }
        },
        addServiceTemplate: {
            title: "Add Service Template",
            inputs: {
                templateName: {
                    label: "Name",
                    placeholder: "Enter a name for the template"
                },
                description: {
                    label: "Description",
                    placeholder: "Enter a description"
                },
                descriptionURL: {
                    label: "Description URL",
                    placeholder: "Enter a URL for the location of documentation for this template"
                },
                template: {
                    label: "Template",
                    placeholder: "Add your template here"
                }
            }
        },
        addVerificationService: {
            title: "Add Verification Service",
            description: `This action will create a new Change Request to ADD a Verification Service.
            When you have finished configuring the Verification Service, SUBMIT the Change Request for review to continue the process. 
            You may also cancel the Change Request at any time prior to deployment using the CANCEL option.`,
            buttons: {
                add: {
                    label: "Add Verification Service"
                },
                create: {
                    label: "Create New Verification Service"
                },
                copy: {
                    label: "Copy Verification Service"
                },
                import: {
                    label: "Import Verification Service"
                },
                validate: {
                    label: "Validate Verification Service"
                }
            },
            inputs: {
                file: {
                    label: "File"
                },
                iWantTo: {
                    label: "I want to"
                }
            }
        },
        addWorkflowTemplate: {
            title: "Add Workflow Template",
            inputs: {
                templateName: {
                    label: "Name",
                    placeholder: "Enter a name for the template"
                },
                description: {
                    label: "Description",
                    placeholder: "Enter a description"
                },
                descriptionURL: {
                    label: "Description URL",
                    placeholder: "Enter a URL for the location of documentation for this template"
                },
                template: {
                    label: "Template",
                    placeholder: "Add your template here"
                }
            }
        },
        addVerificationWorkflow: {
            title: "Create New Verification Workflow",
            description: `Select a Verification workflow template below, fill out the workflows configuration, and click "Deploy Now" to deploy the workflow.`,
            validationPassed: "The Verification Workflow was successfully validated.",
            copyFrom: "Copy From",
            copyTo: "Copy To",
            buttons: {
                addRedirectUrl: {
                    label: "Add Redirect URL"
                },
                deployNow: {
                    label: "Deploy Now"
                },
                createNewRelyingParty: {
                    label: "Create New Relying Party"
                },
                validate: {
                    label: "Validate Verification Workflow"
                }
            },
            inputs: {
                file: {
                    label: "File"
                },
                iWantTo: {
                    label: "I want to"
                },
                name: {
                    label: "Name",
                    placeholder: "Enter the workflow name"
                },
                redirectUrls: {
                    label: "Redirect URLs",
                    placeholder: "https://xxxx.xxxx.xxx"
                }
            },
            importErrors: {
                header: "There were some errors found with contents of the JSON file. The errors have been grouped by the provided Service ID below:",
                footer: "Please fix the issues listed above to continue."
            },
            loadingModal: {
                title: "Almost Done!",
                message: "Please allow a few minutes to complete. You'll be redirected once it's ready.",
                buttonText: "Okay"
            },
            readDocumentation: "Read Documentation"
        },
        archiveVerificationService: {
            title: "Confirm Archival",
            warningTitle: "Warning",
            description: "You are about to archive this service which will immediately make it inactive. You can undo this later.",
            buttons: {
                archiveService: {
                    label: "Archive Service"
                }
            }
        },
        archiveVerificationWorkflow: {
            title: "Confirm Archival",
            warningTitle: "Warning",
            description: "You are about to archive this workflow which will immediately make it inactive. You can undo this later.",
            buttons: {
                archiveWorkflow: {
                    label: "Archive Workflow"
                }
            }
        },
        archiveWorkflowService: {
            title: 'Archive Verification Workflow Service',
            confirmMessage: `Upon archiving the service, this functionality will no longer be accessible within your use case. Please ensure that your policy connections are updated accordingly.`,
            submitButtonText: 'Archive'
        },
        archiveOrganization: {
            title: "Confirm Archival",
            description: "You are about to archive the Organization. It will become inactive and child objects will also be archived.",
            buttons: {
                submit: {
                    label: "Archive Organization"
                }
            }
        },
        archiveOrganizationUser: {
            title: "Confirm Archival",
            description: "You are about to archive this user which will immediately make it inactive. You can undo this later."
        },
        archiveRelyingParty: {
            title: "Confirm Archival",
            description: "You are about to archive the Relying Party. It will become inactive and child objects will also be archived.",
            buttons: {
                submit: {
                    label: "Archive Relying Party"
                }
            }
        },
        confirmAddBackupService: {
            title: "Confirm Adding Backup Attribute Provider",
            descriptionLine1: (serviceName: string) => `Are you sure you want to add a backup attribute provider to ${serviceName}?`,
            descriptionLine2: (serviceName: string) => `This service will execute ONLY when the primary attribute provider vendor (${serviceName}) has an outage. In all other transactions, this attribute provider will be ignored.`,
            buttons: {
                configureBackupService: {
                    label: "Configure Backup Attribute Provider"
                }
            }
        },
        cancelRpServiceChanges: {
            title: "Discard Changes",
            confirmMessage: "You have unsaved changes. Are you sure you want to revert all of the changes made through this modal?",
            buttons: {
                submit: {
                    label: "Yes, revert"
                },
                cancel: {
                    label: "No, remain on the page"
                }
            }
        },
        deleteRelyingParty: {
            title: "Confirm Deletion",
            description: "You are about to delete the Relying Party. All associated child objects (workflows, users, services) will be removed from the system. This action is irreversible, and all data will be permanently lost.",
            buttons: {
                submit: {
                    label: "Delete Relying Party"
                }
            }
        },
        deleteVerificationService: {
            title: "Confirm Deletion",
            warningTitle: "Warning",
            description: "You are about to delete this service which will immediately remove it from use. You can NOT undo this later.",
            buttons: {
                deleteService: {
                    label: "Delete Service"
                },
            }
        },
        deleteOrganization: {
            title: "Confirm Deletion",
            description: "You are about to delete the Organization. All associated child objects (relying parties, workflows, users, services) will be removed from the system. This action is irreversible, and all data will be permanently lost.",
            buttons: {
                submit: {
                    label: "Delete Organization"
                }
            }
        },
        deleteVerificationWorkflow: {
            title: "Confirm Deletion",
            warningTitle: "Warning",
            description: "You are about to delete this workflow which will immediately remove it from use. You can NOT undo this later.",
            buttons: {
                deleteWorkflow: {
                    label: "Delete Workflow"
                }
            }
        },
        deleteOrganizationUser: {
            title: "Confirm Deletion",
            description: "You are about to delete this user which will immediately remove it from use. You can NOT undo this later."
        },
        discardChanges: {
            title: "Discard Changes",
            description: "You have unsaved changes. Are you sure you want to leave this page?",
            buttons: {
                yes: {
                    label: "Yes"
                },
                no: {
                    label: "No, remain on the page"
                }
            }
        },
        importIdentityProviderConfiguration: {
            buttonText: "Import Identity Provider",
            title: "Import Identity Provider",
            description: (name: string) => `This action will overwrite the existing configuration for the Identity Provider named <b>${name}</b> with the data contained in the import file provided.`,
            loadFile: {
                error: {
                    title: "Import Identity Provider Error",
                    message: "An error occurred while parsing the selected file. Please try a different file."
                }
            },
            inputs: {
                file: {
                    label: "File"
                }
            }
        },
        importVerificationServiceConfiguration: {
            buttonText: "Import Verification Service",
            title: "Import Verification Service",
            description: (serviceName: string, apiKey: string) => `This action will overwrite the existing configuration for the Verification Service named <b>${serviceName}</b> with API Key <b>${apiKey}</b> with the data contained in the import file provided.`,
            loadFile: {
                error: {
                    title: "Import Verification Service Error",
                    message: "An error occurred while parsing the selected file. Please try a different file."
                }
            },
            inputs: {
                file: {
                    label: "File"
                }
            }
        },
        importVerificationWorkflowConfiguration: {
            loadFile: {
                error: {
                    title: "Import Verification Workflow Error",
                    message: "An error occurred while parsing the selected file. Please try a different file."
                }
            }
        },
        modifyLandingPageName: {
            title: (landingPageType: LandingPageTypes) => `Modify ${landingPageType}`,
            inputs: {
                landingPage: {
                    label: "Landing Page Name",
                    validation: {
                        empty: "Landing Page Name cannot be blank",
                        noSpaces: "Landing Page Name cannot include spaces"
                    }
                },
                redirectUrl: {
                    label: "Redirect URL",
                    validation: {
                        empty: "Redirect URL cannot be blank",
                        noSpaces: "Redirect URL cannot include spaces"
                    }
                }
            }
        },
        rejectIdentityProviderChangeRequest: {
            buttonText: "Confirm",
            title: "Confirm your Rejection",
            description: "Are you sure you would like to reject this Change Request?",
            inputs: {
                rejectionComments: {
                    label: "Rejection Comments:"
                }
            }
        },
        restoreRelyingParty: {
            title: "Confirm Restore",
            description: "You are about to restore the Relying Party. Please note - Child objects that were archived will not be restored automatically. They must be manually restored.",
            buttons: {
                submit: {
                    label: "Restore Relying Party"
                }
            }
        },
        rejectVerificationServiceChangeRequest: {
            buttonText: "Confirm",
            title: "Confirm your Rejection",
            description: "Are you sure you would like to reject this Change Request?",
            inputs: {
                rejectionComments: {
                    label: "Rejection Comments:"
                }
            }
        },
        restoreOrganization: {
            title: "Confirm Restore",
            description: "You are about to restore the Organization. Please note - Child objects that were archived will not be restored automatically. They must be manually restored.",
            buttons: {
                submit: {
                    label: "Restore Organization"
                }
            }
        },
        restoreVerificationService: {
            title: "Confirm Restoration",
            description: "Proceeding will restore this service, and make it available for configuration and customer interaction again. Click Proceed to continue.",
            buttons: {
                proceed: {
                    label: "Proceed"
                }
            }
        },
        restoreVerificationWorkflow: {
            title: "Confirm Restoration",
            description: "Proceeding will restore this workflow, and make it available for configuration and customer interaction again. Click Proceed to continue.",
            buttons: {
                proceed: {
                    label: "Proceed"
                }
            }
        },
        restoreOrganizationUser: {
            title: "Confirm Restoration",
            description: "Proceeding will restore this user. Click Proceed to continue."
        },
        sessionTimeoutWarning: {
            title: "Session Timeout Warning",
            description: `Your session will expire in 5 minutes. Click the "Keep me logged in" button to continue your session otherwise you will be logged out at the end of your session.`,
            buttons: {
                keepMeLoggedIn: {
                    label: "Keep me logged in"
                }
            }
        },
        updateTemplateJSON: {
            title: "Update Template JSON",
            inputs: {
                templateJSON: {
                    label: "Template JSON"
                }
            },
            errors: {
                jsonValidationError: "There was an error parsing the input JSON string. Please check it and try again."
            }
        },
        verificationLinkProvider: {
            titles: {
                tryNow: "Try Now",
                copyLink: "Copy Link",
                sendEmail: "Send Verification Email To Customer"
            },
            descriptions: {
                tryNow: `Fill in the end user's PII, and click "Try Now" to proceed. This will open the verification workflow in a new tab for you to use.`,
                copyLink: `Fill in the end user's PII, and click "Generate Link" to proceed. You can then copy the URL.`,
                sendEmail: `Fill in the end user's PII, and click "Send Email" to proceed. This will send an email with an identity verification link to their email address.`
            },
            buttonLabels: {
                tryNow: "Try Now",
                copyLink: "Generate Link",
                sendEmail: "Send Email"
            },
            errorModal: {
                message: "Service Configuration API Error",
                detailedMessage: "There was an error retrieving the service data needed. Please try again or contact support."
            },
            inputs: {
                credential: {
                    label: "Credential",
                    placeholder: "Credential"
                },
                recipient: {
                    label: "Recipient",
                    placeholder: "user@example.com"
                },
                appId: {
                    label: "App ID",
                    placeholder: "App ID"
                },
                asi: {
                    label: "ASI",
                    placeholder: "ASI",
                    tooltip: "This field is only used for the API to Gateway integration type"
                },
                prefilledAttributes: {
                    title: "Prefilled Attributes",
                    dob: {
                        label: "Date of Birth"
                    }
                }
            }
        },
        updatePolicyComponent: {
            title: "Update Policy Component",
            confirmMessageTitle: "The change you are about to save will apply to all of the associated policies listed below:",
            confirmMessageDescription: "Click Save to continue with the update. If you wish to update the component for only one policy, please create a new component and assign it to the policy you would like to update."
        },
        updateMessagingTemplate: {
            title: "Update Messaging Template",
            confirmMessageTitle: "The changes you are about to save will apply to all of the services that use this template.",
            confirmMessageDescription: "Click Save to continue with the update. If you wish to update the template for only one service, please create a new template and assign it to the service you would like to update."
        },
        updateEmailTemplate: {
            title: "Update Email Template",
            confirmMessageTitle: "The changes you are about to save will apply to all of the services that use this template.",
            confirmMessageDescription: "Click Save to continue with the update. If you wish to update the template for only one service, please create a new template and assign it to the service you would like to update.",
        },
        updateOrganizationUsersModal: {
            title: "Update User Credentials",
            description: `The IDP has changed for the configured admin login service. You may need to update the credentials for each user to a new value, expected by the newly selected IDP.`,
            inputs: {
                email: {
                    label: "Email"
                },
                credential: {
                    label: "Credential"
                }
            },
            alerts: {
                updated: "Updated",
                notUpdated: "Not Updated"
            }
        },
        verificationLinkProviderResult: {
            title: "Link",
            descriptions: {
                tryNow: `Copy the link below, or click "Open in New Window" to open the link in another tab.`,
                copy: `Use the Copy button below to copy the link.`,
                sendEmail: `An email containing the link below has been sent to the specified recipient. To send it again, click "Resend Email".`
            },
            buttons: {
                resendEmail: {
                    label: "Resend Email"
                },
                resetPii: {
                    label: "Reset PII"
                },
                openInNewWindow: {
                    label: "Open in New Window"
                }
            }
        },
        workflowServiceModal: {
            footerButtons: {
                cancel: {
                    label: "Cancel Changes"
                },
                confirmAndClose: {
                    label: "Confirm Changes"
                },
                close: {
                    label: "Close"
                }
            }
        },
        workflowServiceDetails: {
            title: "Workflow Service Details",
            inputs: {
                service: {
                    label: "Service"
                }
            }
        },
        workflowServicePolicyDecisionDetails: {
            title: "Policy Decision Details"
        },
        verificationTransactionDetailsScores: {
            title: "Trust Score Details",
            trustScorePoints: (points: number) => `IDW Trust Score: ${points}`,
            labels: {
                trustScore: "Trust Score"
            }
        },
        createPolicyComponent: {
            title: "Create New Verification Component",
            description: "Select an option, fill out the details then click on Next",
            steps: {
                triggerConfiguration: {
                    title: "Conditions and Triggers",
                    inputs: {
                        componentType: {
                            label: "Component Type"
                        },
                        trigger: {
                            label: "Trigger Type"
                        },
                        serviceOffering: {
                            label: "Attribute Provider"
                        },
                        assertion: {
                            label: "Assertion Name"
                        },
                        assertionStatus: {
                            label: "Assertion Status"
                        },
                        attribute: {
                            label: "Attribute Name"
                        },
                        acquiredAttribute: {
                            label: "Acquired Attribute Name"
                        },
                        attributeField: {
                            label: "Attribute Field Name"
                        },
                        component: {
                            label: "Component Name"
                        },
                        comparison: {
                            label: "Comparison"
                        },
                        value: {
                            label: "Value"
                        }
                    }
                }

            },
            inputs: {
                componentCreationMode: {
                    label: "I want to"
                },
                organization: {
                    label: "Organization"
                },
                name: {
                    label: "Name"
                },
                description: {
                    label: "Description"
                },
                category: {
                    label: "Category"
                },
                status: {
                    label: "Status"
                },
                components: {
                    label: "Component List"
                }
            }

        }
    },
    navigationMenuItems: {
        dashboard: {
            title: "Dashboard"
        },
        workflows: {
            title: "Workflows"
        },
        verificationServices: {
            title: "Verification Services"
        },
        identityProviders: {
            title: "Identity Providers"
        },
        messagingTemplates: {
            title: "Messaging Templates"
        },
        emailTemplates: {
            title: "Email Templates"
        },
        organization: {
            title: "Organization",
            children: {
                details: {
                    title: "Details"
                },
                activity: {
                    title: "Activity"
                },
                users: {
                    title: "Users"
                },
                invitations: {
                    title: "Invitations"
                }
            }
        },
        relyingParties: {
            title: "Relying Parties"
        },
        policyComponents: {
            title: "Policy Components"
        },
        alerts: {
            title: "Alerts",
            children: {
                alertEvents: {
                    title: "Alert Events"
                },
            }
        },
        reports: {
            title: "Reports",
            children: {
                transactions: {
                    title: "Transactions"
                },
                servicePerformance: {
                    title: "Service Performance"
                },
                serviceComparison: {
                    title: "Service Comparison"
                },
                workflowUsageDetails: {
                    title: "Workflow Usage Details"
                },
                workflowReport: {
                    title: "Workflow Report"
                },
                fraudReport: {
                    title: "Fraud Report"
                },
                userSummary: {
                    title: "User Summary"
                },
                adaptiveAuthentication: {
                    title: "Adaptive Authentication"
                }
            }
        },
        managementConsole: {
            title: "Management Console",
            children: {
                axn: {
                    title: "AXN",
                    children: {
                        cache: {
                            title: "Cache"
                        },
                        config: {
                            title: "Config"
                        },
                        sessions: {
                            title: "Sessions"
                        }
                    }
                },
                axnAdmin: {
                    title: "AXN Admin",
                    children: {
                        cache: {
                            title: "Cache"
                        },
                        config: {
                            title: "Config"
                        },
                        logging: {
                            title: "Logging"
                        },
                        securityRules: {
                            title: "Security Rules"
                        },
                        sessions: {
                            title: "Sessions"
                        }
                    }
                },
                masterData: {
                    title: "Master Data",
                    children: {
                        attributeLabels: {
                            title: "Attribute Labels"
                        },
                        serviceTemplates: {
                            title: "Service Templates"
                        },
                        workflowTemplates: {
                            title: "Workflow Templates"
                        }
                    }
                }
            }
        },
        disclosures: {
            title: "Disclosures"
        },
        help: {
            title: "Help"
        },
        logout: {
            title: "Logout"
        },
        copyright: {
            title: `IDDataweb ${new Date().getFullYear()}`
        }
    },
    pages: {
        adaptiveAuthentication: {
            header: "ADAPTIVE AUTHENTICATION REPORT",
        },
        alertEvents: {
            header: "ALERT EVENTS",
            searchForm: {
                description: "Use the form below to refine your alert events search parameters",
                filters: {
                    alerts: {
                        label: "Alerts"
                    },
                }
            },
        },
        attributeLabelDetails: {
            header: "ATTRIBUTE LABEL UPDATE"
        },
        attributeLabels: {
            header: "ATTRIBUTE LABELS",
            headerButton: "Add a new attribute Label"
        },
        axnAdminCache: {
            header: "AXNADMIN CACHE",
            loadingIndicatorText: "Refreshing Cache"
        },
        axnAdminConfig: {
            header: "AXNADMIN CONFIG",
            loadingIndicatorText: "Refreshing Config"
        },
        axnAdminLogging: {
            header: "AXNADMIN LOGGING",
            loadingIndicatorText: "Refreshing Logging"
        },
        axnAdminSessions: {
            header: "AXNADMIN SESSIONS"
        },
        axnCache: {
            header: "AXN CACHE",
            loadingIndicatorText: "Refreshing Cache"
        },
        axnConfig: {
            header: "AXN CONFIG",
            loadingIndicatorText: "Refreshing Config"
        },
        axnSessions: {
            header: "AXN SESSIONS",
        },
        dashboard: {
            header: "DASHBOARD",
        },
        fraudReport: {
            header: "FRAUD REPORT",
            headerButton: "Download Detailed Report",
            searchForm: {
                filters: {
                    assertions: {
                        label: "Assertions"
                    },
                    riskLevels: {
                        label: "Risk Levels"
                    },
                }
            }
        },
        help: {
            header: "HELP"
        },
        login: {
            authenticating: "Authenticating...",
            welcomeText: "Welcome to AXN Admin",
            corporateEmailButtonLabel: "Corporate Email",
            corporateEmailButtonText: "Continue",
            googleLoginButton: "Continue with Google",
            copyright: (currentYear: string) => `IDDataweb 2016 - ${currentYear}`,
            moreInfo: "More Info",
            errors: {
                userNotFound: "This account has not been set up for AXN Admin access.",
                securityCheckFailure: "You did not pass the required security checks, please try again.",
                orgLoginNotSupported: "Your organization does not have SSO enabled.",
                loginFailure: "There was an issue with your login.",
                invitationExpired: "Your invitation has expired. Please request a new invitation.",
                invitationInvalid: "There was an issue with your invitation. Please contact support@iddataweb.com.",
                invitationUsed: "This invitation has already been used. Please request a new invitation.",
                sessionTimeout: "Your session has timed out. Please log back in to continue using the application."
            }
        },
        identityProviders: {
            header: "IDENTITY PROVIDERS",
            headerButton: "Add Identity Provider",
            errors: {
                invalidConfiguration: {
                    title: "IDP Configuration Error",
                    message: "There was an error retrieving the IDP data needed. Please try again or contact support."
                }
            },
            dropdownItems: {
                open: {
                    label: "Open Identity Provider Details"
                }
            }
        },
        identityProviderDetails: {
            header: "IDENTITY PROVIDER DETAILS",
            buttons: {
                approveChanges: {
                    label: "Approve Changes"
                },
                rejectChanges: {
                    label: "Reject Changes"
                }
            },
            tabs: {
                generalInfo: {
                    tabName: "General Info",
                    header: "General Info",
                    description: "To start the IDP onboarding process, first define the IDP protocol from the available options below",
                    inputs: {
                        protocol: {
                            label: "Protocol"
                        },
                        identityProviderName: {
                            label: "Identity Provider Name"
                        },
                        code: {
                            label: "Code"
                        },
                        category: {
                            label: "Category"
                        },
                        organization: {
                            label: "Organization"
                        },
                        redirectUrl: {
                            label: "Redirect URL"
                        }
                    }
                },
                organization: {
                    tabName: "Organization IDP Info",
                    header: "Organization IDP Info",
                    inputs: {
                        scope: {
                            label: "Scope"
                        },
                        clientId: {
                            label: "Client ID"
                        },
                        clientSecret: {
                            label: "Client Secret"
                        },
                        authorizationUrl: {
                            label: "Authorization URL"
                        },
                        tokenUrl: {
                            label: "Token URL"
                        },
                        userInfoUrl: {
                            label: "User Info URL"
                        },
                        userCredential: {
                            label: "User Credential"
                        },
                        jwksUrl: {
                            label: "JWKS URL"
                        },
                        wellknownUrl: {
                            label: "Wellknown URL"
                        },
                        tokenAuthenticationScheme: {
                            label: "Token Authentication Scheme"
                        }
                    }
                },
                urlParameters: {
                    tabName: "Custom URL Parameters",
                    header: "Custom URL Parameters",
                    headerButton: "Add New Parameter",
                    inputs: {
                        parameterKey: {
                            placeholder: "Parameter Key",
                            label: "Key"
                        },
                        parameterValue: {
                            placeholder: "Parameter Value",
                            label: "Value"
                        },
                        urlType: {
                            label: "URL Type"
                        }
                    }
                },
                federatedAttributes: {
                    tabName: "Federated Attributes",
                    header: "Federated Attributes",
                    headerButton: "Add New Attribute",
                    inputs: {
                        idpField: {
                            label: "Key",
                            placeholder: "IDP Field"
                        },
                        attributeType: {
                            label: "Attribute Type"
                        },
                        iddatawebField: {
                            label: "Iddataweb Field"
                        }
                    }
                }
            },
        },
        messagingTemplateDetails: {
            header: "MESSAGING TEMPLATE DETAILS",
            tabs: {
                generalInfo: {
                    title: "General Info",
                    tabName: "General Info",
                    inputs: {
                        name: {
                            label: "Template Name",
                            placeholder: "Enter a name for the template"
                        },
                        type: {
                            label: "Template Type"
                        },
                        status: {
                            label: "Status"
                        }
                    }
                },
                content: {
                    title: "Content",
                    tabName: "Content",
                    sections: {
                        template: {
                            title: "Template",
                            description: "You can use variables within the template to support multiple languages. To do so, add text with the following format:\n\n${(variable_name_goes_here)!\"default_message_goes_here\"}"
                        }
                    },
                    inputs: {
                        template: {
                            label: "Template Content",
                            placeholder: "Add your HTML Template Content here"
                        }
                    }
                },
                variables: {
                    title: "Variables",
                    tabName: "Variables",
                    noVariablesMessage: "Your template does not have any translatable variables.",
                    noLanguageMessage: (language: string, isDisabled: boolean) => `This messaging template does not currently support ${language}. ${isDisabled ? "" : 'To add support, click "Add Language" below'}`,
                    sections: {
                        variables: {
                            title: "Variables",
                            description: "You can configure what the user will see for each language by selecting the appropriate language in this section and updating the text for your variables in the inputs below."
                        }
                    },
                    inputs: {
                        language: {
                            label: "Language"
                        }
                    },
                    buttons: {
                        addLanguage: {
                            label: "Add Language"
                        }
                    }
                }
            }
        },
        messagingTemplates: {
            header: "MESSAGING TEMPLATES",
            headerButton: "Add a new Messaging Template"
        },
        emailTemplates: {
            header: "EMAIL TEMPLATES",
            headerButton: "Add a new Email Template"
        },
        emailTemplateDetails: {
            header: "EMAIL TEMPLATE DETAILS",
            tabs: {
                generalInfo: {
                    title: "General Info",
                    tabName: "General Info",
                    inputs: {
                        name: {
                            label: "Template Name",
                            placeholder: "Enter a name for the template"
                        },
                        sender: {
                            label: "Sender",
                            placeholder: "Enter the sender's email address"
                        },
                        type: {
                            label: "Template Type"
                        },
                        status: {
                            label: "Status"
                        }
                    }
                },
                content: {
                    title: "Content",
                    tabName: "Content",
                    sections: {
                        template: {
                            title: "Template",
                            description: "You can use variables within the template to support multiple languages. To do so, add text with the following format:\n\n${(variable_name_goes_here)!\"default_message_goes_here\"}"
                        }
                    },
                    inputs: {
                        template: {
                            label: "Template Content",
                            placeholder: "Add your HTML Template Content here"
                        }
                    }
                },
                variables: {
                    title: "Variables",
                    tabName: "Variables",
                    noVariablesMessage: "Your template does not have any translatable variables.",
                    sections: {
                        variables: {
                            title: "Variables",
                            description: "You can configure what the user will see for each language by selecting the appropriate language in this section and updating the text for your variables in the inputs below."
                        }
                    },
                    defaultSender: {
                        title: "admin@iddataweb.com",
                        description: "You can configure the sender as long as it is white listed and pre-approved in the system. Otherwise will use the default",
                        error: "the default sender cannot be empty and must be a valid email"
                    },
                    inputs: {
                        language: {
                            label: "Language"
                        }
                    },
                    buttons: {
                        addLanguage: {
                            label: "Add Language"
                        }
                    }
                }
            }
        },
        organizationActivity: {
            header: "ORGANIZATION ACTIVITY"
        },
        organizationDetails: {
            header: "ORGANIZATION DETAILS",
            tabs: {
                details: {
                    tabName: "Details",
                    title: "General Information",
                    inputs: {
                        organizationName: { label: "Organization Name" },
                        organizationCode: { label: "Organization Code" },
                        customerSupportTier: { label: "Tier Name" }
                    }
                },
                adminLoginSettings: {
                    tabName: "Admin Login Settings",
                    noCorporateLoginMessage: `This organization currently uses the default login service to authenticate users to the Admin Console. Clicking "Create Corporate Login" will set up a custom login service for the organization. After creation, the service can be modified to use a Federated SSO as the Identity Provider if necessary.`,
                    updateUserCredentialsWarnigmessage: `In order to save these changes, you may also need to update the credentials for the users in the organization. To do so, follow the instructions in the modal shown after clicking on the save button`,
                    inputs: {
                        enableCorporateLogin: {
                            label: "Enable Admin Login"
                        },
                        createCorporateLogin: {
                            label: "Create Corporate Login"
                        },
                        serviceName: {
                            label: "Service Name"
                        },
                        apiKey: {
                            label: "APIKey"
                        },
                        idpName: {
                            label: "IDP Name"
                        }
                    },
                    buttons: {
                        createIDP: {
                            label: "Create a new IDP"
                        }
                    }
                }

            },
            placeholders: {
                organizationName: "Enter the organization name"
            }
        },
        organizationInvitationDetails: {
            header: "INVITATION UPDATE",
            inputs: {
                email: {
                    label: "Email"
                },
                role: {
                    label: "Role"
                },
                relyingParty: {
                    label: "Relying Party"
                },
                status: {
                    label: "Status"
                }
            }
        },
        organizationInvitations: {
            header: "USER INVITATIONS",
            headerButton: "Invite a new user"
        },
        organizationUserDetails: {
            title: "USER DETAILS",
            tabs: {
                details: {
                    tabName: "Details",
                    title: "Details",
                    accessMessage: "This user has at least one Relying Party Role for a Relying Party that you do not have access to.",
                    preferences: {
                        title: "Preferences",
                        inputs: {
                            label: "Receive Change Request Emails Notification",
                        },
                    },
                    inputs: {
                        firstName: {
                            label: "First Name"
                        },
                        lastName: {
                            label: "Last Name"
                        },
                        email: {
                            label: "Email",
                            placeholder: "user@example.com"
                        },
                        credential: {
                            label: "Credential",
                            placeholder: "user@example.com"
                        },
                        roleType: {
                            label: "Role Type"
                        },
                        role: {
                            label: "Role"
                        },
                        relyingParty: {
                            label: "Relying Party"
                        },
                        relyingPartyRoles: {
                            label: "Relying Party Role(s)",
                            description: "Add this user to individual Relying Parties with a specific role."
                        },
                        identityProvider: {
                            label: "Identity Provider"
                        },
                        status: {
                            label: "Status"
                        }
                    },
                    buttons: {
                        addRelyingPartyRole: {
                            label: "Add Relying Party Role"
                        },
                        resetPassword: {
                            label: "Reset Password"
                        }
                    }
                },
                adminApiAccess: {
                    tabName: "Admin API Access",
                    title: "Admin API Access",
                    inputs: {
                        apiAccess: {
                            label: "Api Access"
                        },
                        username: {
                            label: "Username"
                        },
                        password: {
                            label: "Password"
                        }
                    }
                },
                permissionsPanel: {
                    tabName: "Permissions Panel",
                    title: "Permissions Panel",
                    sections: {
                        admin: {
                            title: "User is IDDW Admin"
                        },
                        organizationPermissions: {
                            title: "Organization Permissions"
                        },
                        relyingPartyPermissions: {
                            title: "Relying Party Permissions"
                        }
                    }
                },
                activity: {
                    tabName: "Activity",
                    title: "Activity"
                }
            }
        },
        organizations: {
            header: "ORGANIZATIONS",
            headerButton: "Add a new organization"
        },
        organizationUsers: {
            header: "ORGANIZATION USERS",
            roleAccessFilter: {
                label: "Filter user list by access level"
            },
            headerButton: "Invite a new user"
        },
        relyingParties: {
            header: "RELYING PARTIES",
            headerButton: "Add Relying Party",
            headerButtonDisabledText: "You have reached the maximum number of relying parties allowed for your current subscription tier. To continue adding more relying parties, please delete unused relying parties, upgrade your subscription, or contact support for further assistance."
        },
        relyingPartyDetails: {
            header: "RELYING PARTY DETAILS",
            tabs: {
                details: {
                    tabName: "Details",
                    title: "General Information",
                    inputs: {
                        name: { label: "Name" },
                        blockBuyCode: { label: "Block Buy Code" }
                    }
                },
                customHostnames: {
                    tabName: "Custom Hostnames",
                    title: "Custom Hostnames",
                    inputs: {
                        axn: {
                            label: "AXN",
                            placeholder: "White Label AXN Host Name (https://hostname.com)"
                        },
                        axnui: {
                            label: "AXNUI",
                            placeholder: "White Label AXNUI Host Name (https://hostname.com)"
                        },
                        kbaui: {
                            label: "KBAUI",
                            placeholder: "White Label KBAUI Host Name (https://hostname.com)"
                        },
                        dcui: {
                            label: "DCUI",
                            placeholder: "White Label DCUI Host Name (https://hostname.com)"
                        },
                        axnui2: {
                            label: "(Deprecated) AXNUI v2",
                            placeholder: "White Label AXNUI v2 Host Name (https://hostname.com)"
                        },
                        kba: {
                            label: "(Deprecated) KBAUI v2",
                            placeholder: "White Label KBAUI v2 Host Name (https://hostname.com)"
                        },
                        dc: {
                            label: "(Deprecated) DCUI v1",
                            placeholder: "White Label DCUI v1 URL Host Name (https://hostname.com)"
                        }
                    }
                }
            }
        },
        policyComponents: {
            header: "POLICY COMPONENTS",
            headerButton: "Add Policy Component"
        },
        policyComponentDetails: {
            header: "POLICY COMPONENT DETAILS",
            tabs: {
                generalInformation: {
                    title: "General Info",
                    inputs: {
                        decisionType: {
                            label: "Decision Type"
                        },
                        class: {
                            label: "Class"
                        }
                    }
                },
                associatedPolicies: {
                    title: "Associated Policies"
                }
            }
        },
        securityRuleDetails: {
            header: "SECURITY RULE DETAILS",
            idAlreadyExistsMessage: "ID Already Exists!",
            idIsAvailableMessage: "ID is available!",
            checking: "Checking...",
            inputs: {
                id: {
                    label: "ID"
                },
                className: {
                    label: "Class Name"
                },
                pathText: {
                    label: "Path Text"
                },
                ruleName: {
                    label: "Rule Name"
                },
                rule: {
                    label: "Rule"
                }
            }
        },
        securityRules: {
            header: "SECURITY RULES",
            headerButton: "Add Security Rule",
            refreshHeader: "SECURITY RULES - REFRESH",
            refreshHeaderButton: "Refresh",
            loadingIndicatorText: "Refreshing Security Rules",
        },
        serviceAssertionPerformance: {
            header: "SERVICE ASSERTION PERFORMANCE REPORT",
            searchForm: {
                filters: {
                    verificationServiceRevision: {
                        label: "Verification Service Revision",
                        presentText: "present"
                    }
                }
            }
        },
        serviceAssertionPerformanceComparison: {
            header: "SERVICE ASSERTION PERFORMANCE COMPARISON REPORT",
            searchForm: {
                filters: {
                    verificationServiceRevision: {
                        label: "Verification Service Revision",
                        presentText: "present"
                    }
                }
            }
        },
        serviceTemplates: {
            header: "SERVICE TEMPLATES",
            headerButton: "Add Service Template"
        },
        serviceTemplateDetails: {
            title: "SERVICE TEMPLATE DETAILS",
            tabs: {
                metadata: {
                    tabName: "Metadata",
                    header: "METADATA",
                    buttons: {
                        updateTemplateJSON: {
                            label: "Update Template JSON"
                        }
                    },
                    inputs: {
                        name: {
                            label: "Name",
                            placeholder: "Enter a name for the service template"
                        },
                        description: {
                            label: "Description",
                            placeholder: "Enter a description for the service template"
                        },
                        descriptionURL: {
                            label: "Description URL",
                            placeholder: "Enter a URL which points to a documentation page describing the template"
                        },
                        templateJSON: {
                            label: "Template JSON",
                            placeholder: "Add your template here"
                        }
                    }
                }
            }
        },
        userSummary: {
            header: "MONTHLY USERS REPORT"
        },
        verificationServiceDetails: {
            header: "VERIFICATION SERVICE CONFIGURATION",
            inputs: {
                language: {
                    label: "Language",
                    tooltip: "This dropdown contains all of the languages that have been configured for your workflow. Use it to choose which language to preview and configure."
                }
            },
            buttons: {
                approveChanges: {
                    label: "Approve Changes"
                },
                rejectChanges: {
                    label: "Reject Changes"
                }
            },
            tabs: {
                common: {
                    alerts: {
                        notAuthorizedToViewProperties: "Your account does not have permission to view service properties",
                        notAuthorizedToModifyProperties: "Your account does not have permission to modify service properties",
                        noPropertiesMessage: (propertyCategory: string, isDisabled: boolean) =>
                            `No ${propertyCategory} have been added.${!isDisabled ? " Click Add Property to add one now." : ""}`,
                        allPropertiesMessage: (propertyCategory: string) => `All of the available ${propertyCategory} have been added.`
                    }
                },
                general: {
                    tabName: "General",
                    subTabs: {
                        basicInfo: {
                            tabName: "Basic Info",
                            title: "General Settings - Basic Info",
                            buttons: {
                                addRedirectUrl: {
                                    label: "Add Redirect URL"
                                }
                            },
                            inputs: {
                                serviceName: {
                                    label: "Service Name",
                                    placeholder: "Enter a name for the service",
                                    validationError: "The Service Name cannot be blank"
                                },
                                apiKey: {
                                    label: "API Key",
                                    placeholder: "Provide an API key",
                                    validationError: "The API Key cannot be blank"
                                },
                                sharedSecret: {
                                    label: "Shared Secret",
                                    placeholder: "Provide a Shared Secret",
                                    validationError: "The Shared Secret cannot be blank"
                                },
                                redirectUrls: {
                                    label: "Redirect URL(s)",
                                    placeholder: "https://xxxx.xxxx.xxx",
                                    helpText: "Add redirect url(s) to be associated with this service. Valid urls must not contain any spaces and must be unique",
                                    serviceBelongToWorkflowWarningMessage: "Redirect Urls can only be configured from Workflow Configuration pages. You can view the configuration here, but you will not be able to update it here.",
                                    validationErrors: {
                                        emptyUrl: "At least one redirect URL is empty",
                                        invalidUrl: "At least one redirect URL includes a space",
                                        uniqueUrl: "At least two redirect URLs are not unique",
                                        atLeastOneUrl: "Please enter at least One Redirect URL"
                                    }
                                }
                            }
                        },
                        serviceType: {
                            tabName: "Service Type",
                            title: "General Settings - Service Type",
                            description: "AXN provides two categories of verification services",
                            sso: {
                                title: "AXN Manage - Adaptive Single Sign-On",
                                description: "Manage the log in and verification process for users as well as reverification during subsequent visits"
                            },
                            uvo: {
                                title: "AXN Verify - User Verification & Onboarding",
                                description: "One-time user verification for customers to manage users themselves"
                            }
                        },
                        integrationType: {
                            tabName: "Integration Type",
                            title: "General Settings - Integration Type",
                            descriptionLine1: "AXN provides the AXN Gateway User Interface for collecting user attributes as well as an API that allows customer-managed attribute collection.",
                            descriptionLine2: "If you wish to use the AXN Gateway User Interface, there are addittional settings that you may configure to control the display and functionality of the user attribute input interface.",
                            options: {
                                enable: "Enable the AXN Gateway",
                                disable: "Use the AXN API Only"
                            }
                        },
                        advanced: {
                            tabName: "Advanced",
                            title: "General Settings - Advanced",
                            inputs: {
                                errorUrl: {
                                    label: "Error URL",
                                    placeholder: "https://xxxx.xxxxx.xx"
                                },
                                endpointType: {
                                    label: "Endpoint Type",
                                    warning: "Changing the endpoint type to a value other than 2 will inactivate any active policies that have been setup."
                                }
                            },
                            sections: {
                                loginHint: {
                                    title: "Login Hint",
                                    description: "Enable your workflow to accept prefilled PII to the verification form.",
                                    errors: {
                                        noLoginHintMethodChoiceErrorText: "Please select the desired method",
                                        noJWTPublicKeyErrorText: "Please generate a public key",
                                        noJWTPrivateKeyErrorText: "Please generate a private key"
                                    },
                                    buttons: {
                                        copyPublicKey: {
                                            title: "Copy Public Key"
                                        },
                                        copyPrivateKey: {
                                            title: "Copy Private Key"
                                        },
                                        viewPublicKey: {
                                            title: "View Public Key"
                                        },
                                        viewPrivateKey: {
                                            title: "View Private Key"
                                        },
                                        generateKeys: {
                                            label: "Generate Keys"
                                        },
                                        clearKeys: {
                                            label: "Clear Keys"
                                        }
                                    },
                                    inputs: {
                                        enableLoginHint: {
                                            label: "Enable Login Hint"
                                        },
                                        securityMethod: {
                                            label: "Select the security method"
                                        },
                                        loginHintPlainJSON: {
                                            label: "Credential Only",
                                            tooltipText: `Pass the credential of the user. URL Encode the following: {"credential":"test"} and include as the login_hint value.`
                                        },
                                        loginHintJWTSigned: {
                                            label: "Login Hint JWT signed",
                                            tooltipText: "Pass additional PII of the user in JWT format. The JWT is digitally signed using the client_secret."
                                        },
                                        loginHintJWTEncrypted: {
                                            label: "Login Hint JWT encrypted",
                                            tooltipText: "Pass additional PII of the user in JWT format with encryption. The JWT is encrypted using a keypair defined below."
                                        },
                                        loginHintJWTEncryptedPrivateKey: {
                                            label: "Generate your private key"
                                        },
                                        loginHintJWTEncryptedPublicKey: {
                                            label: "Generate your public key"
                                        },
                                        expireLoginHint: {
                                            label: "Expire Login Hint"
                                        },
                                        loginHintExpirationType: {
                                            label: "Expiration Type",
                                        },
                                        loginHintDuration: {
                                            label: "Duration (in minutes)"
                                        },
                                        loginHintExpirationDate: {
                                            label: "Expiration Date"
                                        }

                                    }
                                },
                                pinCode: {
                                    title: "PIN Code Settings",
                                    description: "This section will allow you to customize PIN Code settings for One-Time Passcodes.",
                                    inputs: {
                                        pinResendAndValidationAttempts: {
                                            label: "PIN Validation Attempts",
                                            tooltip: "Set the number of allowable attempts for sending and validating a PIN code.",
                                            validationErrors: {
                                                required: "Please enter a number between 2 and 50 for the PIN Send and Validation Attempts limit"
                                            }
                                        },
                                        pinTimeout: {
                                            label: "PIN Timeout (minutes)",
                                            tooltip: "Set the timeout for the PIN code in minutes. When a PIN code expires, it will no longer be valid.",
                                            validationErrors: {
                                                required: "Please enter a number greater than 1 for the PIN Timeout"
                                            }
                                        },
                                        generateStaticPinCode: {
                                            label: "Testing - Static PIN Code",
                                            tooltip: "Enable a static PIN code for testing purposes. All transactions will receive the same PIN Code configured under this setting."
                                        },
                                        staticPinCode: {
                                            label: "Static PIN Value",
                                            tooltip: "Enter the desired 6-digit code for testing purposes.",
                                            validationErrors: {
                                                required: "Please enter a 6 digit PIN Code"
                                            }
                                        },
                                        mockSendEmailPin: {
                                            label: "Testing - Suppress Email PIN Code",
                                            tooltip: "Suppress the Email PIN code for testing purposes; all transactions will not trigger or deliver a PIN code."
                                        }
                                    }
                                },
                                webhookConfiguration: {
                                    title: "Webhook Configuration",
                                    description: "This section will allow you to configure your webhook setup.",
                                    advancedSettings: "Advanced Settings",
                                    inputs: {
                                        enableWebook: {
                                            label: "Enable Webhook",
                                            tooltip: "Provide the minimum required information for your webhook integration; use the advanced section for additional settings."
                                        },
                                        webhookUrl: {
                                            label: "Webhook URL",
                                            tooltip: "The URL which AXN will send (https POST) the JSON results to.",
                                            validationErrors: {
                                                required: "Please enter a valid Webhook URL. Valid URLs begin with http:// or https:// and do not include spaces or quotes"
                                            }
                                        },
                                        secureWebhook: {
                                            label: "Secure Webhook",
                                            tooltip: "No authentication means that the webhook does not require any credentials or tokens to access the endpoint. Basic authentication involves sending a username and password encoded in base64 with each request. It can also include some advanced settings. OAuth2 is a more secure and complex method that involves token-based authentication. The client requests an access token from the authorization server, which is then used to authenticate requests."
                                        },
                                        includeUserData: {
                                            label: "Include User Data",
                                            tooltip: "Include end user PII in the endpoint."
                                        },
                                        webhookFileName: {
                                            label: "Replace API Key Value",
                                            tooltip: "Replace API key value with a custom string. Useful for OneTrust integrations.",
                                            validationErrors: {
                                                invalid: "Please enter a valid Webhook File Name. Valid file names are 1 - 30 characters long and contain only alphanumeric characters, dashes and underscores"
                                            }
                                        },
                                        addWebhookWrapperObject: {
                                            label: "Add Webhook Wrapper Object",
                                            tooltip: "Wraps the standard JSON object in a named value. Useful for Sailpoint Integrations."
                                        },
                                        webhookWrapperObjectName: {
                                            label: "Webhook Wrapper Object Name",
                                            validationErrors: {
                                                required: "Please enter a valid Webhook Wrapper Object Name. Valid wrapper object names contain only alphanumeric characters are 1 - 30 characters long"
                                            }
                                        },
                                        setToFlatEndpoint: {
                                            label: "Add Flat Endpoint",
                                            tooltip: "Enable this field if you would like to receive the response as flat value pair list instead of nested object"
                                        },
                                        webhookAuthUser: {
                                            label: "Username",
                                            validationErrors: {
                                                required: "Please enter a valid Username. Valid usernames do not include spaces and are 1 - 30 characters long"
                                            }
                                        },
                                        webhookAuthPass: {
                                            label: "Password",
                                            validationErrors: {
                                                required: "Please enter a valid Password. Valid passwords do not include spaces and are at least 8 characters long"
                                            }
                                        },
                                        webhookTokenUrl: {
                                            label: "Token Url",
                                            tooltip: "The Token URL which AXN will use to retrieve the token for the webhook POST.",
                                            validationErrors: {
                                                required: "Please enter a valid Webhook Token URL. Valid URLs begin with http:// or https:// and do not include spaces or quotes"
                                            }
                                        },
                                        webhookTokenClientID: {
                                            label: "Client ID",
                                            validationErrors: {
                                                required: "Please enter a valid Client ID. Valid IDs do not include spaces"
                                            }
                                        },
                                        webhookTokenClientSecret: {
                                            label: "Client Secret",
                                            validationErrors: {
                                                required: "Please enter a valid Client Secret. Valid secrets do not include spaces"
                                            }
                                        }
                                    }
                                },
                                sessionCustomization: {
                                    title: "Session Settings",
                                    description: "This section will allow you to customize your session timeout",
                                    inputs: {
                                        asiTimeout: {
                                            label: "Session Time (minutes)",
                                            tooltipText: "The session timeout is set to 30 minutes by default. To adjust the time, enable this section and enter the desired session timeframe in minutes."

                                        }
                                    },
                                    validationErrors: {
                                        asiTimeout: {
                                            asiTimeoutValueError: "Please select a valid timeout"
                                        }
                                    }
                                },
                                tmxEventType: {
                                    title: "TMX Event Type",
                                    description: "This section will allow you to configure the TMX Event Type being used for TMX attribute providers",
                                    inputs: {
                                        setTmxEventType: {
                                            label: "Set TMX Event Type",
                                            tooltipText: "Enable this section to specify which TMX Event Type should be used for TMX attribute providers"
                                        },
                                        tmxEventType: {
                                            label: "TMX Event Type"
                                        }
                                    }
                                },
                                prefilledCredentials: {
                                    title: "Credentials Mapping",
                                    descriptionText: "This section will allow you to map an attribute as the credentials.",
                                    inputs: {
                                        enabledPrefilledCredential: {
                                            label: "Enable Credentials Mapping",
                                            tooltipText: "Enable the radio button and select the attribute to use as the credentials."
                                        },
                                        selectAttribute: {
                                            label: "Select Attribute"
                                        }
                                    },
                                    validationErrors: {
                                        selectAttribute: {
                                            prefilledCredentialAttributeError: "Please select an attribute"
                                        }
                                    },
                                    description: "This section will allow you to map an attribute as the credentials.",

                                },
                                incodeSms: {
                                    title: "Incode SMS",
                                    descriptionText: "This section will allow you to override the default SMS provider for document capture SMS delivery.",
                                    inputs: {
                                        enableIncodeSms: {
                                            label: "Override Incode SMS Provider"
                                        },
                                        messagingService: {
                                            label: "Select an SMS Provider"
                                        }
                                    }
                                },
                                properties: {
                                    title: "Properties",
                                    description: "Service properties by category",
                                    sections: {
                                        generalProperties: {
                                            title: "General Properties",
                                            description: "Properties that could apply to any RPService",
                                            buttons: {
                                                addProperty: {
                                                    label: "Add General Property"
                                                }
                                            }
                                        },
                                        gatewayProperties: {
                                            title: "Gateway Properties",
                                            propertyType: "Gateway Properties",
                                            description: "Properties that apply to the Gateway UI",
                                            buttons: {
                                                addProperty: {
                                                    label: "Add Gateway Property"
                                                }
                                            }
                                        }
                                    }
                                },
                                workflowRedirectToCallbackUrlOnError: {
                                    title: "Redirect On Error",
                                    description: "This section allows gateway integrations to enable the gateway to automatically redirect incoming traffic to the redirect URL configured when an error occurs.",
                                    inputs: {
                                        redirectOnError: {
                                            label: "Enable Redirect on Error",
                                            tooltip: "This feature is available for gateway integrations and redirects traffic to a configured URL when an error occurs. It includes the error code and description enabling customers to build an effective error handling system and ensuring a seamless end-user experience."
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                services: {
                    tabName: "Attribute Providers",
                    subTabs: {
                        common: {
                            buttons: {
                                addProperty: {
                                    label: "Add Property"
                                },
                                addService: {
                                    label: "Add Attribute Provider"
                                },
                                addBackupService: {
                                    label: "Add Backup Attribute Provider"
                                },
                                removeBackupService: {
                                    label: "Remove Backup Attribute Provider"
                                }
                            },
                            labels: {
                                backupService: "Backup Attribute Provider:"
                            },
                            inputs: {
                                dataSource: {
                                    label: "Data Source"
                                }
                            },
                            alerts: {
                                noServiceOfferingsMessage: (soCategory: string, isDisabled: boolean) =>
                                    `No ${soCategory} attribute providers have been added.${!isDisabled ? " Click Add Attribute Provider to add one now." : ""}`,
                                allServiceOfferingsMessage: (soCategory: string) =>
                                    `All of the available ${soCategory} attribute providers have been added.`,
                                invalidFallbackServiceOfferingMessage: `This attribute provider has been configured with an invalid fallback attribute provider. Please contact our support team to fix this.`
                            }
                        },
                        humanIdentity: {
                            tabName: "Human Identity",
                            title: "Attribute Providers - Human Identity",
                            description: "Select attribute providers for verifying user identity such as name, address and social security number",
                            serviceOfferingCategory: "Human Identity"
                        },
                        relationships: {
                            tabName: "Relationships",
                            title: "Attribute Providers - Relationships",
                            description: "Select attribute providers for verifying employment, group membership or affiliations",
                            serviceOfferingCategory: "Relationships"

                        },
                        environmental: {
                            tabName: "Environmental",
                            title: "Attribute Providers - Environmental",
                            description: "Select attribute providers for validating environmental risk factors",
                            serviceOfferingCategory: "Environmental"
                        },
                        runOrder: {
                            tabName: "Run Order",
                            title: "Attribute Providers - Run Order",
                            description: "Choose the order of attribute provider execution in each group below",
                            sections: {
                                duringVerify: {
                                    title: "During Verify"
                                },
                                redirect: {
                                    title: "Redirect"
                                },
                                postVerify: {
                                    title: "Post Verify"
                                },
                                penultimateVerify: {
                                    title: "Penultimate Verify"
                                },
                                finalVerify: {
                                    title: "Final Verify"
                                },
                                asynchronous: {
                                    title: "Asynchronous"
                                }
                            }
                        },
                        properties: {
                            tabName: "Properties",
                            title: "Attribute Providers - Properties",
                            sections: {
                                serviceOfferingProperties: {
                                    title: "Attribute Providers Properties",
                                    description: "Properties that apply to specific Attribute Providers"
                                },
                                documentCaptureProperties: {
                                    title: "Document Capture UI Properties",
                                    description: "Properties that apply to the display of the Document Capture application"
                                }
                            }
                        }
                    }
                },
                attributes: {
                    tabName: "Attributes",
                    title: "Attributes",
                    description: "Select the attributes you would like to use. Drag and drop them to choose the order in which they will be displayed",
                    noAttributesMessage: (isDisabled: boolean) => `No attributes have been added.${!isDisabled ? " Click Add Attribute to add one now." : ""}`,
                    allAttributesMessage: "All of the available attributes have been added.",
                    canNotModifyLabels: "This service is not configured to allow the customization of attribute labels. In order to customize attribute labels, you must either add the property mergeThemingAndLocalizedFile OR remove the property localizeStrings.",
                    buttons: {
                        addAttribute: {
                            label: "Add Attribute"
                        },
                        showAdvanced: {
                            label: "Show Advanced"
                        },
                        addLabel: {
                            label: "Add Label"
                        }
                    },
                    inputs: {
                        visible: {
                            label: "Visible"
                        },
                        optional: {
                            label: "Optional"
                        },
                        editable: {
                            label: "Editable"
                        },
                        placeholder: {
                            label: "Placeholder"
                        },
                        autosubmit: {
                            label: "Autosubmit"
                        },
                        asynchronous: {
                            label: "Asynchronous"
                        },
                        ignorePDSData: {
                            label: "Ignore PDS Data"
                        },
                        saveToPDS: {
                            label: "Save to PDS"
                        },
                        customTooltip: {
                            label: "Custom Tooltip"
                        },
                        requiredForSelfServiceVerification: {
                            label: "Required for Self Service Verification?"
                        }
                    }
                },
                assertions: {
                    tabName: "Assertions",
                    subTabs: {
                        apAssertions: {
                            title: (serviceOfferingName: string) => `Assertions - ${serviceOfferingName}`,
                            description: (serviceOfferingName: string) => `Select the assertions you would like from ${serviceOfferingName}`,
                            buttons: {
                                addAssertion: {
                                    label: "Add Assertion"
                                }
                            },
                            noApAssertionsMessage: (serviceOfferingName: string, isDisabled: boolean) => `No assertions have been added from ${serviceOfferingName}.${!isDisabled ? " Click Add Assertion to add one now" : ""}.`,
                            allApAssertionsMessage: (serviceOfferingName: string) => `All of the available ${serviceOfferingName} assertions have been added.`,
                            missingAttributesMessage: (attributeName: string) => `This claim needs the ${attributeName} in order to be correctly returned to your app.`
                        }
                    }
                },
                scores: {
                    tabName: "Scores",
                    subTabs: {
                        assertionScore: {
                            tabName: "Assertion Score",
                            title: "Scores - Assertion Score",
                            description:
                                "The Assertion Score allows you to assign point values to the assertions that have been configured for this service and to calculate an overall score based on the results of those assertions.",
                            sections: {
                                assertionScoreModifiers: {
                                    title: "Assertion Score Modifiers",
                                    maximumPossibleAssertionLabel: "Maximum Possible Assertion Points",
                                    noAssertionScoreModifierLabel: "There are no assertion score modifiers",
                                    invalidAssertionScoreError: "Please make sure to set at least one score value",
                                }
                            }
                        },
                        trustScore: {
                            tabName: "Trust Score",
                            title: "Scores - Trust Score",
                            description: `The Trust Score provides an overall score based on scores generated from other services, including the Assertion Score (if enabled).
                            You can choose which scores to include in the calculation and how you want to weight each of those scores.
                            You can also assign penalties and bonuses based on the results of individual claims/assertions to customize your results.`,
                            deprecatedWarningMessage: "Warning: Deprecated Trust Score service is in use. Please speak to your Solutions Architect to upgrade.",
                            sections: {
                                serviceOfferingWeights: {
                                    title: "Attribute Provider Weights",
                                    instruction: "Assign a weight to each attribute provider.",
                                    error: {
                                        noScoreEnableWarningMessage: "You have not selected an attribute provider that affects the IDW Trust Score. IDW Trust Score works only when paired with at least one of the following services",
                                        noScoreEnableWarningMessage2: "Add one of the above attribute providers to enable IDW Trust Score scoring.",
                                        noTrustScoreComponentEnabledError: "* At least one score component must be enabled for IDW Trust Score calculation"
                                    },
                                },
                                trustScoreModifiers: {
                                    noTrustScoreModifierLabel: "There are no trust score modifiers"
                                }

                            }
                        }
                    },
                    table: {
                        columns: {
                            assertion: {
                                header: "Assertion",
                            },
                            serviceOffering: {
                                header: "Attribute Provider",
                            },
                            pass: {
                                header: "Pass",
                            },
                            close: {
                                header: "Close",
                            },
                            partial: {
                                header: "Partial",
                            },
                            unverified: {
                                header: "Unverified",
                            },
                            fail: {
                                header: "Fail"
                            },
                            warn: {
                                header: "Warn",
                            }
                        }
                    }

                },
                dcuiTheming: {
                    tabName: "Document Capture",
                    subTabs: {
                        common: {
                            inputs: {
                                title: {
                                    label: "Title",
                                    tooltip: (captureStepType: string) => `Title for the ${captureStepType} Capture Page`
                                },
                                instructions: {
                                    label: "Instructions",
                                    tooltip: (captureStepType: string) => `${captureStepType} capture instructions. This will be parsed as HTML so you can include simple formatting tags`
                                },
                                showScreenOrientationPreview: {
                                    label: "Show Screen Orientation Preview Text",
                                    tooltip: "Enables/disables showing the instructional screen orientation preview text"
                                },
                                screenOrientationPreviewText: {
                                    label: "Screen Orientation Preview Text",
                                    tooltip: "Text shown with the screen orientation preview video"
                                },
                                useCustomVideoOrImage: {
                                    label: "Use a custom video or an image",
                                    tooltip: "Use a custom instructional screen orientation video"
                                },
                                customMediaUrl: {
                                    label: "Custom Media",
                                    tooltip: (contentSlot: string) => `Upload an image or a video to be used for the ${contentSlot} custom media. Supported formats are png, gif, jpg/jpeg and mp4`
                                },
                                captureButtonLabel: {
                                    label: "Capture Button Label",
                                    tooltip: (captureStepType: string) => `Text for the button that opens the native (phone) camera for the ${captureStepType} capture step`
                                }
                            }
                        },
                        theme: {
                            tabName: "Theme",
                            title: "Theme",
                            description: "You can customize here the general look and feel of the Document Capture application",
                            sections: {
                                general: {
                                    title: "General",
                                    inputs: {
                                        font: {
                                            label: "Font",
                                            tooltip: "The default font used by the application"
                                        },
                                        primaryButtonTextColor: {
                                            label: "Primary Button Text Color",
                                            tooltip: "The primary text color used in the app for buttons"
                                        },
                                        primaryButtonBackgroundColor: {
                                            label: "Primary Button Background Color",
                                            tooltip: "The primary color used in the app for buttons"
                                        },
                                        secondaryButtonTextColor: {
                                            label: "Secondary Button Text Color",
                                            tooltip: "The secondary text color used in the app for buttons"
                                        },
                                        secondaryButtonBackgroundColor: {
                                            label: "Secondary Button Background Color",
                                            tooltip: "The secondary color used in the app for buttons"
                                        }
                                    }
                                },
                                header: {
                                    title: "Header",
                                    inputs: {
                                        backgroundColor: {
                                            label: "Background Color",
                                            tooltip: "The background color applied to the header",
                                        }
                                    }
                                },
                                headerText: {
                                    inputs: {
                                        addHeaderText: {
                                            label: "Add Header Text",
                                            tooltip: "Show or hide some text in the header"
                                        },
                                        headerText: {
                                            label: "Header Text",
                                            tooltip: "The header text"
                                        },
                                        headerTextPosition: {
                                            label: "Header Text Position",
                                            tooltip: "Choose the alignment of the header text. Acceptable alignment values are left, right, or center"
                                        },
                                        headerTextColor: {
                                            label: "Header Text Color",
                                            tooltip: "Choose the color of the text in the header. Make sure to choose a color that contrasts well with the header's background color"
                                        },
                                    }
                                },
                                headerLogo: {
                                    inputs: {
                                        addHeaderLogo: {
                                            label: "Add Header Logo",
                                            tooltip: "Show or hide a logo in the header"
                                        },
                                        headerLogo: {
                                            label: "Header Logo",
                                            tooltip: "Upload an image to be used for the header logo. Supported formats are png, gif, jpg/jpeg"
                                        },
                                        headerLogoPosition: {
                                            label: "Header Logo Position",
                                            tooltip: "Choose the alignment of the logo in the header. Acceptable alignment values are left, right, or center"
                                        }
                                    }
                                },
                                footer: {
                                    title: "Footer",
                                    inputs: {
                                        backgroundColor: {
                                            label: "Footer Background Color",
                                            tooltip: "The background color applied to the footer"
                                        },
                                        footerText: {
                                            label: "Footer Text",
                                            tooltip: "The footer text"
                                        },
                                        footerTextPosition: {
                                            label: "Footer Text Position",
                                            tooltip: "Choose the alignment of text in the footer. Acceptable alignment values are left, right, or center"
                                        },
                                        footerTextColor: {
                                            label: "Footer Text Color",
                                            tooltip: "Choose the color of the text in the footer. Make sure to choose a color that contrasts well with the footer's background color"
                                        }
                                    }
                                }
                            }
                        },
                        startPage: {
                            tabName: "Start Page",
                            title: "Start Page",
                            description: "This is the entry point of the Document Capture application. The user is given a quick overview of the steps involved in the process. You can customize the text to your liking.",
                            sections: {
                                content: {
                                    title: "Content",
                                    inputs: {
                                        headline: {
                                            label: "Headline",
                                            tooltip: "Headline content for the page"
                                        },
                                        title: {
                                            label: "Title",
                                            tooltip: "Title for the page"
                                        },
                                        subheading: {
                                            label: "Subheading",
                                            tooltip: "Subheading for the page"
                                        },
                                        explanation: {
                                            label: "Explanation",
                                            tooltip: "Content aimed at explaining the capture process and flow. It will be parsed as html so you can include simple HTML tags"
                                        }
                                    }
                                },
                                captureSteps: {
                                    title: "Capture Steps",
                                    inputs: {
                                        startInstructionsImageLabel: {
                                            label: (captureStepType: string) => `${captureStepType} Step Label`,
                                            tooltip: (captureStepType: string) => `Text that appears on the Start Page for the ${captureStepType} Capture Step`
                                        },
                                        useCustomStartInstructionsImage: {
                                            label: (captureStepType: string) => `Use a custom ${captureStepType} image`,
                                            tooltip: (captureStepType: string) => `Enables/disables the use of a custom Start Page instruction image for the ${captureStepType} Capture Step`
                                        },
                                        startInstructionsImageUrl: {
                                            label: (captureStepType: string) => `${captureStepType} Image`,
                                            tooltip: (contentSlot: string) => `Upload an image to be used for the ${contentSlot} Start Page instruction. Supported formats are png, gif, and jpg/jpeg`
                                        }
                                    }
                                },
                                buttons: {
                                    title: "Buttons",
                                    inputs: {
                                        startButtonText: {
                                            label: "Start Button Text",
                                            tooltip: "Text for the button that starts the flow"
                                        },
                                        startButtonLoadingText: {
                                            label: "Start Button Loading Text",
                                            tooltip: "Text shown while the flow is being prepared, after clicking the Start Button"
                                        }
                                    }
                                }
                            }
                        },
                        driverLicenseFront: {
                            tabName: "DL Front",
                            title: "Driver License Front",
                            description: "The current configuration requires the user to provide a snapshot of the front of their Driver License. This page will direct the user through this process."
                        },
                        driverLicenseBack: {
                            tabName: "DL Back",
                            title: "Driver License Back",
                            description: "The current configuration requires the user to provide a snapshot of the back of their Driver License. This page will direct the user through this process."
                        },
                        idCardFront: {
                            tabName: "ID Front",
                            title: "ID Card Front",
                            description: "The current configuration requires the user to provide a snapshot of the front of their ID Card. This page will direct the user through this process."
                        },
                        idCardBack: {
                            tabName: "ID Back",
                            title: "ID Card Back",
                            description: "The current configuration requires the user to provide a snapshot of the back of their ID Card. This page will direct the user through this process."
                        },
                        passport: {
                            tabName: "Passport",
                            title: "Passport",
                            description: "The current configuration requires the user to provide a snapshot of their passport. This page will direct the user through this process."
                        },
                        selfie: {
                            tabName: "Selfie",
                            title: "Selfie",
                            description: "The current configuration requires the user to provide a snapshot of their face. This page will direct the user through this process."
                        },
                        captureComplete: {
                            tabName: "Capture Complete",
                            title: "Capture Complete Page",
                            description:
                                "Once the user has captured all necessary pictures, they will be directed to this page. Depending on your configuration, this will either be the last page in the flow, or they might be redirected to complete the flow. You can customize the content of this page.",
                            inputs: {
                                uploadCompleteTitle: {
                                    label: "Upload Complete Title",
                                    tooltip: "Title of the section shown when all images are uploaded"
                                },
                                uploadInProgressTitle: {
                                    label: "Upload In Progress Title",
                                    tooltip: "Title for the final Capture page"
                                },
                                uploadSuccessMessageWithRedirect: {
                                    label: "Upload Success Message (with redirect)",
                                    tooltip: "Message shown when the upload was successful and we are getting ready to redirect the user to the app"
                                },
                                uploadSuccessMessageWithoutRedirect: {
                                    label: "Upload Success Message (without redirect)",
                                    tooltip: "Message shown when the upload was successful, but there is no redirect URL"
                                },
                                uploadErrorMessage: {
                                    label: "Upload Error Message",
                                    tooltip: "Message shown when the image upload fails"
                                }
                            }
                        },
                        error: {
                            tabName: "Error Page",
                            title: "Error Page",
                            description:
                                "If anything goes wrong during the document capture flow, the user will be redirected to this page. You can customize the general error message shown to the user.",
                            inputs: {
                                title: {
                                    label: "Title",
                                    tooltip: "Title for the error page"
                                },
                                instructions: {
                                    label: "Instructions",
                                    tooltip: "Content of the error message"
                                },
                                transactionId: {
                                    label: "Transaction ID Label",
                                    tooltip: "Label that appears before the transaction ID (if present)"
                                }
                            }
                        },
                        customCss: {
                            tabName: "Custom CSS",
                            title: "Custom CSS",
                            description: "You can apply global css styles here",
                            inputs: {
                                customCss: {
                                    label: "Custom CSS",
                                    tooltip: "If you want to apply a style globally, you can set the CSS style here"
                                }
                            }
                        },
                        textContent: {
                            tabName: "Text Content",
                            title: "Text Content",
                            description: "You can customize the rest of the text content in the Document Capture application that is not specific to a particular page.",
                            sections: {
                                browserWarnings: {
                                    title: "Browser Warnings",
                                    inputs: {
                                        iosSafariBrowserWarningText: {
                                            label: "IOS Safari Browser Warning Text",
                                            tooltip: "The warning message show to iOS users who are not using Safari"
                                        },
                                        desktopSafariBrowserWarningText: {
                                            label: "Desktop Safari Browser Warning Text",
                                            tooltip: "The warning message shown to Mac users who are not using Safari"
                                        },
                                        androidChromeBrowserWarningText: {
                                            label: "Android Chrome Browser Warning Text",
                                            tooltip: "The warning message shown to Android users who are not using Chrome"
                                        },
                                        desktopChromeBrowserWarningText: {
                                            label: "Desktop Chrome Browser Warning Text",
                                            tooltip: "The warning message shown to Desktop users who are not using Chrome"
                                        }
                                    }
                                },
                                general: {
                                    title: "General",
                                    inputs: {
                                        qualityAdviceMessage: {
                                            label: "Quality Advice Message",
                                            tooltip: "The quality advice message that appears on each capture screen"
                                        },
                                        continueButtonText: {
                                            label: "Continue Button Text",
                                            tooltip: "Text for the Continue action button. After a preview, clicking this button will save the captured image and go to the next capture step in the process"
                                        },
                                        discardButtonText: {
                                            label: "Discard Button Text",
                                            tooltip: "Text for the Discard action button. After a preview, clicking this button will restart the capture and discard the captured image"
                                        },
                                        capturingText: {
                                            label: "Capturing Text",
                                            tooltip: "Message shown in the app when the camera is opened"
                                        },
                                        processingText: {
                                            label: "Processing Text",
                                            tooltip: "Message shown in the app while the image is being processed"
                                        },
                                        relaunchCaptureButtonText: {
                                            label: "Relaunch Capture Button Text",
                                            tooltip: "Text for the button used to restart the capture process when something goes wrong"
                                        },
                                        relaunchCaptureLabelText: {
                                            label: "Relaunch Capture Label Text",
                                            tooltip: "Message shown above the relaunch button explaining how to relaunch the camera"
                                        },
                                        captureErrorText: {
                                            label: "Capture Error Text",
                                            tooltip: "Message shown when the application has an error while processing an image"
                                        }
                                    }
                                },
                                validation: {
                                    sections: {
                                        common: {
                                            inputs: {
                                                subheading: {
                                                    label: (validationType: string) => `${validationType} Detection Title`,
                                                    tooltip: (validationType: string) => `Title for the ${validationType} Detection section`
                                                },
                                                loadingText: {
                                                    label: (validationType: string) => `${validationType} Detection Loading Text`,
                                                    tooltip: (validationType: string) => `Text shown while the ${validationType} Detection validation is running`
                                                },
                                                successMessage: {
                                                    label: (validationType: string) => `${validationType} Detection Success Text`,
                                                    tooltip: (validationType: string) => `Message shown when the ${validationType} Detection validation succeeds`
                                                },
                                                errorMessage: {
                                                    label: (validationType: string) => `${validationType} Detection Error Text`,
                                                    tooltip: (validationType: string) => `Message shown when the ${validationType} Detection validation fails`
                                                }
                                            }
                                        },
                                        general: {
                                            title: "Validation - General",
                                            inputs: {
                                                title: {
                                                    label: "Title",
                                                    tooltip: "Title for the Validation section"
                                                },
                                                loadingText: {
                                                    label: "Loading Text",
                                                    tooltip: "Text shown while the validation is running"
                                                },
                                            }
                                        },
                                        portrait: {
                                            displayText: "Portrait"
                                        },
                                        landscape: {
                                            displayText: "Landscape"
                                        },
                                        badResolution: {
                                            displayText: "Bad Resolution"
                                        },
                                        faceDetection: {
                                            displayText: "Face"
                                        },
                                        generic: {
                                            title: (validationType: string) => `Validation - ${validationType} Detection`
                                        },
                                        acuant: {
                                            badResolution: {
                                                displayText: "Bad Resolution"
                                            },
                                            blurDetection: {
                                                displayText: "Blur"
                                            },
                                            glareDetection: {
                                                displayText: "Glare"
                                            },
                                            liveness: {
                                                displayText: "Liveness"
                                            },
                                            generic: {
                                                title: (validationType: string) => ` Acuant Validation - ${validationType} Detection`
                                            },
                                        }
                                    }
                                },
                                acuantCamera: {
                                    title: "Acuant - Camera",
                                    inputs: {
                                        none: {
                                            label: "Camera None Text",
                                            tooltip: "Message shown in the camera overlay when no document is detected"
                                        },
                                        tapToCapture: {
                                            label: "Tap To Capture Text",
                                            tooltip: "Message shown in the camera overlay, when auto-capture is not available, that instructs the user how to capture their document"
                                        },
                                        smallDocument: {
                                            label: "Camera Small Document Text",
                                            tooltip: "Message shown in the camera overlay when a document is detected to be too far away from the camera"
                                        },
                                        bigDocument: {
                                            label: "Camera Big Document Text",
                                            tooltip: "Message shown in the camera overlay when a document is detected to be too close to the camera"
                                        },
                                    }
                                }
                            }
                        }
                    }
                },
                theming: {
                    tabName: "Theming",
                    subTabs: {
                        common: {
                            inputs: {
                                contentType: {
                                    label: "What kind of content would you like to add?"
                                },
                                predefinedFormHelpTextType: {
                                    label: "Predefined Form Help Text",
                                    tooltip: (contentSlot: string) => `The predefined text that you want to show in the ${contentSlot} section. You can set a predefined text among many default texts`
                                },
                                customHtml: {
                                    label: "Custom HTML Template",
                                    tooltip: (elementName: string) => `HTML added here will appear in the ${elementName} element.`+"You can use variables within the template. To do so, add text with the following format:\n\n${(variable_name_goes_here)!\"default_message_goes_here\"}.",
                                    sections: {
                                        variables: {
                                            title: "Variables",
                                            description: "You can configure what the user will see and updating the text for your variables in the inputs below. If empty, the default text will be shown in the preview.",
                                            noVariablesMessage: "Your template does not have any translatable variables."
                                        }
                                    }
                                },
                                customCss: {
                                    label: "Custom CSS",
                                    tooltip: (elementName: string) => `CSS added here will apply to the custom HTML in the ${elementName} element`
                                },
                                image: {
                                    label: "Image",
                                    tooltip: (contentSlot: string) => `Upload an image to be used in the ${contentSlot} section. Supported formats are png, gif, and jpg/jpeg`
                                },
                                imagePosition: {
                                    label: "Image Position",
                                    tooltip: (contentSlot: string) => `The alignment of the ${contentSlot} image. Acceptable alignment values are left, right, or center`
                                },
                                imageWidth: {
                                    label: "Image Width",
                                    tooltip: "Width of the image (in pixels)"
                                },
                                imageHeight: {
                                    label: "Image Height",
                                    tooltip: "Height of the image (in pixels)"
                                },
                                imageAltText: {
                                    label: "Image Alt Text",
                                    tooltip: "Alternative text of the image (This text will be shown if the image cannot be displayed)"
                                },
                                modalLinkText: {
                                    label: "Modal Link Text",
                                    tooltip: "Modal link text"
                                },
                                modalText: {
                                    label: "Modal Text",
                                    tooltip: "HTML added here will appear in the modal element"
                                },
                                modalCss: {
                                    label: "Modal CSS",
                                    tooltip: "CSS added here will apply to the custom HTML in the modal element"
                                },
                                explicitConsent: {
                                    label: "Consent Text",
                                    tooltip: "The message that appears next to the required consent checkbox"
                                }
                            }
                        },
                        layout: {
                            tabName: "Layout",
                            title: "Layout",
                            description: "You can customize the general look and feel of the application here",
                            sections: {
                                general: {
                                    title: "General",
                                    inputs: {
                                        addPageHeader: {
                                            label: "Add a Page Header",
                                            tooltip: "Enables/disables display of the page header"
                                        },
                                        addPageFooter: {
                                            label: "Add a Page Footer",
                                            tooltip: "Enables/disables display of the page footer"
                                        },
                                        favicon: {
                                            label: "Favicon",
                                            tooltip: "Upload an image to be used for the favicon. Supported formats are png, gif, and jpg/jpeg"
                                        },
                                    }
                                },
                                style: {
                                    title: "Style",
                                    inputs: {
                                        font: {
                                            label: "Font",
                                            tooltip: "The default font used by the application"
                                        },
                                        fontColor: {
                                            label: "Font Color",
                                            tooltip: "The primary text color used in the application"
                                        },
                                        linksColor: {
                                            label: "Links Color",
                                            tooltip: "The primary text color used in the application for links"
                                        },
                                        mainButtonTextColor: {
                                            label: "Main Button Text Color",
                                            tooltip: "Text color used throughout the application for buttons"
                                        },
                                        mainButtonBackgroundColor: {
                                            label: "Main Button Background Color",
                                            tooltip: "Background color used throughout the application for buttons"
                                        },
                                    }
                                },
                                background: {
                                    title: "Background",
                                    inputs: {
                                        backgroundColor: {
                                            label: "Background Color",
                                            tooltip: "Background color used throughout the application"
                                        },
                                        backgroundImage: {
                                            label: "Background Image",
                                            tooltip: "Upload an image to be used for the outer background. Supported formats are png, gif, jpg/jpeg"
                                        },
                                        imagePosition: {
                                            label: "Image Position",
                                            tooltip: "The background position option allows you to move a background image around within its container"
                                        },
                                        imageSize: {
                                            label: "Image Size",
                                            tooltip: "The size of the background image"
                                        },
                                        imageRepeat: {
                                            label: "Image Repeat",
                                            tooltip: "Whether the background image should repeat or not"
                                        },
                                        imageAttachment: {
                                            label: "Image Attachment",
                                            tooltip: "Whether the background image should scroll or be fixed with the page"
                                        }
                                    }
                                },
                                languageSelector: {
                                    title: "Language Selector",
                                    inputs: {
                                        enableLanguageSelector: {
                                            label: "Enable Language Selector",
                                            tooltip: ""
                                        }
                                    }
                                }
                            }
                        },
                        header: {
                            tabName: "Header",
                            title: "Header",
                            description: "You can customize the page header here",
                            sections: {
                                background: {
                                    title: "Background",
                                    inputs: {
                                        backgroundColor: {
                                            label: "Header Background Color",
                                            tooltip: "The background color applied to the header"
                                        },
                                    }
                                },
                                headerText: {
                                    title: "Header Text",
                                    inputs: {
                                        addHeaderText: {
                                            label: "Add Header Text",
                                            tooltip: "Show or hide some text in the header"
                                        },
                                        headerText: {
                                            label: "Header Text",
                                            tooltip: "The header text"
                                        },
                                        headerTextPosition: {
                                            label: "Header Text Position",
                                            tooltip: "Choose the alignment of the header text. Acceptable alignment values are left, right, or center"
                                        },
                                        headerTextColor: {
                                            label: "Header Text Color",
                                            tooltip: "Choose the color of the text in the header. Make sure to choose a color that contrasts well with the header's background color"
                                        },
                                    }
                                },
                                headerLogo: {
                                    title: "Header Logo",
                                    inputs: {
                                        addHeaderLogo: {
                                            label: "Add Header Logo",
                                            tooltip: "Show or hide a logo in the header"
                                        },
                                        headerLogo: {
                                            label: "Header Logo",
                                            tooltip: "Upload an image to be used for the header logo. Supported formats are png, gif, jpg/jpeg"
                                        },
                                        headerLogoPosition: {
                                            label: "Header Logo Position",
                                            tooltip: "Choose the alignment of the logo in the header. Acceptable alignment values are left, right, or center"
                                        },
                                        headerLogoAltText: {
                                            label: "Header Logo Alt Text",
                                            tooltip: "Alternative text of the header logo. This text will be shown if the image cannot be displayed"
                                        },
                                    }
                                },
                                customHtmlAndCss: {
                                    title: "Custom HTML & CSS",
                                    inputs: {
                                        useCustomHtmlAndCss: {
                                            label: "Use Custom HTML & CSS instead",
                                            tooltip: "Enables/disables the ability to apply Custom HTML and CSS to the header"
                                        },
                                        customHtml: {
                                            label: "Custom HTML",
                                            tooltip: "HTML added here will appear in the header element"
                                        },
                                        customCss: {
                                            label: "Custom CSS",
                                            tooltip: "CSS added here will apply to the custom HTML in the header element"
                                        }
                                    }
                                }
                            }
                        },
                        footer: {
                            tabName: "Footer",
                            title: "Footer",
                            description: "You can customize the page footer here",
                            sections: {
                                background: {
                                    title: "Background",
                                    inputs: {
                                        backgroundColor: {
                                            label: "Footer Background Color",
                                            tooltip: "The background color applied to the footer"
                                        }
                                    }
                                },
                                footerText: {
                                    title: "Footer Text",
                                    inputs: {
                                        footerText: {
                                            label: "Footer Text",
                                            tooltip: "The footer text"
                                        },
                                        footerTextPosition: {
                                            label: "Footer Text Position",
                                            tooltip: "Choose the alignment of text in the footer. Acceptable alignment values are left, right, or center"
                                        },
                                        footerTextColor: {
                                            label: "Footer Text Color",
                                            tooltip: "Choose the color of the text in the footer. Make sure to choose a color that contrasts well with the footer's background color"
                                        },
                                    }
                                },
                                customHtmlAndCss: {
                                    title: "Custom HTML & CSS",
                                    inputs: {
                                        useCustomHtmlAndCss: {
                                            label: "Use Custom HTML & CSS instead",
                                            tooltip: "Enables/disables the ability to apply Custom HTML and CSS to the footer"
                                        },
                                        customHtml: {
                                            label: "Custom HTML",
                                            tooltip: "HTML added here will appear in the footer element"
                                        },
                                        customCss: {
                                            label: "Custom CSS",
                                            tooltip: "CSS added here will apply to the custom HTML in the footer element"
                                        }
                                    }
                                }
                            }
                        },
                        actionButton: {
                            tabName: "Action Button",
                            title: "Action Button",
                            description: "You can customize the action button for the page now",
                            asyncMessage: "Based on the current configuration, end users of this service will be asked to continue the verification flow on their mobile device. Use the section below to customize the text for the button directing the user to their mobile device.",
                            inputs: {
                                useCustomButtonText: {
                                    label: "Use Custom Button Text",
                                    tooltip: "In case the default button texts don't fulfill your use case, a custom button text can be provided as well. Note that if the service is configured with at least one Document Capture attribute, the text shown will default to 'Continue On Mobile' which is itself customizable"
                                },
                                customButtonText: {
                                    label: "Custom Button Text",
                                    tooltip: "Custom button text value"
                                },
                                defaultButtonText: {
                                    label: "Default Button Text",
                                    tooltip: "Select one of the available default button texts"
                                },
                                asyncButtonText: {
                                    label: "Continue On Mobile Button Text",
                                    tooltip: "Default text value when the form includes at least one Document Capture attribute with an incomplete status (the documents haven't been uploaded yet). Once the documents get uploaded, the button text will be one of the defaults or the custom text accordingly."
                                },
                                buttonBackgroundColor: {
                                    label: "Button Background Color",
                                    tooltip: "The background color of the action button"
                                },
                                buttonTextColor: {
                                    label: "Button Text Color",
                                    tooltip: "The text color of the action button"
                                },
                                buttonBorderRadius: {
                                    label: "Button Border Radius",
                                    tooltip: "The border radius of the action button (in pixels)"
                                }
                            }
                        },
                        formPanel: {
                            tabName: "Form Panel",
                            title: "Form Panel",
                            description: "You can customize the form panel here",
                            sections: {
                                background: {
                                    title: "Background",
                                    inputs: {
                                        backgroundColor: {
                                            label: "Form Panel Background Color",
                                            tooltip: "The background color of the form panel"
                                        }
                                    }
                                },
                                formPanelTitle: {
                                    title: "Form Panel Title",
                                    inputs: {
                                        addFormPanelTitle: {
                                            label: "Add a Form Panel Title",
                                            tooltip: "Enables/disables display of the form panel title"
                                        },
                                        formPanelTitle: {
                                            label: "Form Panel Title Text",
                                            tooltip: "The form panel title text"
                                        },
                                        formPanelTitlePosition: {
                                            label: "Form Panel Title Position",
                                            tooltip: "The alignment of the form panel title. Acceptable alignment values are left, right, or center"
                                        },
                                        formPanelTitleTextColor: {
                                            label: "Form Panel Title Text Color",
                                            tooltip: "The text color of the form panel title"
                                        },
                                    }
                                },
                                formPanelLogo: {
                                    title: "Form Panel Logo",
                                    inputs: {
                                        addFormPanelLogo: {
                                            label: "Add a Form Panel Logo",
                                            tooltip: "Enables/disables display of the form panel logo"
                                        },
                                        formPanelLogo: {
                                            label: "Form Panel Logo",
                                            tooltip: "Upload an image to be used for the form panel logo. Supported formats are png, gif, jpg/jpeg"
                                        },
                                        formPanelLogoPosition: {
                                            label: "Form Panel Logo Position",
                                            tooltip: "The alignment of the form panel logo. Acceptable alignment values are left, right, or center"
                                        },
                                        formPanelLogoWidth: {
                                            label: "Form Panel Logo Width",
                                            tooltip: "The form panel logo width (in pixels)"
                                        },
                                        formPanelLogoHeight: {
                                            label: "Form Panel Logo Height",
                                            tooltip: "The form panel logo height (in pixels)"
                                        },
                                        formPanelLogoAltText: {
                                            label: "Form Panel Logo Alt Text",
                                            tooltip: "Alternative text of the form panel logo. This text will appear if the image cannot be displayed."
                                        }
                                    }
                                },
                                formPanelDescription: {
                                    title: "Form Panel Description",
                                    inputs: {
                                        formPanelDescriptionText: {
                                            label: "Form Panel Description Text",
                                            tooltip: "The form panel description text"
                                        }
                                    }
                                }
                            }
                        },
                        preFormContentSlot: {
                            tabName: "Pre Form Content Slot",
                            title: "Pre Form Content Slot",
                            description: "You can add content here that will be shown just before the first form input",
                            buttons: {
                                add: {
                                    label: "Add"
                                }
                            },
                            sections: {
                                order: {
                                    title: "Order the content"
                                }
                            }
                        },
                        formContent: {
                            tabName: "Form Content",
                            title: "Form Content",
                            description: "You can customize the messages that certain form inputs have on this page",
                            sections: {
                                documentCapturePlaceholder: {
                                    title: "Document Capture Placeholder",
                                    inputs: {
                                        captureMessage: {
                                            label: "Capture Message",
                                            tooltip: "Text displayed in the Document Capture elements prior to the user uploading an image of their document"
                                        },
                                        statusText: {
                                            label: "Status Text",
                                            tooltip: "Text displayed in the Document Capture elements prior to the actual status of their upload"
                                        },
                                        completeStatusText: {
                                            label: "Complete Status Text",
                                            tooltip: "Text displayed in the Document Capture elements when a user has successfully uploaded their document"
                                        },
                                        incompleteStatusText: {
                                            label: "Incomplete Status Text",
                                            tooltip: "Text displayed in the Document Capture elements when a user has not yet uploaded an image of their document"
                                        },
                                        failedStatusText: {
                                            label: "Failed Status Text",
                                            tooltip: "Text displayed in the Document Capture elements when a user attempted to upload an image of their document, but the attempt failed"
                                        },
                                        unableToVerifyStatusText: {
                                            label: "Unable to Verify Status Text",
                                            tooltip: "Text displayed in the Document Capture elements when a user uploaded an image of their document, but the image provided did not pass verification"
                                        },
                                        previewTextSingle: {
                                            label: "Preview Text Single",
                                            tooltip: "The preview text you can see for a single document capture (e.g. a selfie)"
                                        },
                                        previewTextMultiple: {
                                            label: "Preview Text Multiple",
                                            tooltip: "The preview text you can see for a single document capture with two sides (e.g. Drivers License Front and Back)"
                                        }
                                    }
                                },
                                asyncModalTexts: {
                                    title: "Async Modal Texts",
                                    inputs: {
                                        continueInfoEmailText: {
                                            label: "Continue Info Email Text",
                                            tooltip: "Text displayed at the top of the Async Modal when the async process is initiated through an email"
                                        },
                                        continueInfoPhoneText: {
                                            label: "Continue Info Phone Text",
                                            tooltip: "Text displayed at the top of the Async Modal when the async process is initiated through a text message"
                                        },
                                        detailText: {
                                            label: "Detail Text",
                                            tooltip: "Text displayed below the Continue Info in the Async Modal to provide more details about the async process"
                                        },
                                        cancelButtonText: {
                                            label: "Cancel Button Text",
                                            tooltip: "Text displayed for the cancel button in the Async Modal"
                                        },
                                        noRetriesLeftText: {
                                            label: "No Retries Left Text",
                                            tooltip: "Text displayed in the Async Modal when a user has no retries left"
                                        },
                                        asyncSubmissionCompleteText: {
                                            label: "Async Submission Complete Text",
                                            tooltip: "Text displayed in the Async Modal when the process is complete"
                                        },
                                        asyncSubmissionInProgressText: {
                                            label: "Async Submission In Progress Text",
                                            tooltip: "Text displayed in the Async Modal while the process is in progress"
                                        }
                                    }
                                }
                            }
                        },
                        postFormContentSlot: {
                            tabName: "Post Form Content Slot",
                            title: "Post Form Content Slot",
                            description: "You can add content here that will be shown just after the last form input but before the submit button",
                            buttons: {
                                add: {
                                    label: "Add"
                                }
                            },
                            sections: {
                                order: {
                                    title: "Order the content"
                                }
                            }
                        },
                        postSubmitContentSlot: {
                            tabName: "Post Submit Content Slot",
                            title: "Post Submit Content Slot",
                            description: "You can add content here that will be shown just after the submit button",
                            buttons: {
                                add: {
                                    label: "Add"
                                }
                            },
                            sections: {
                                order: {
                                    title: "Order the content"
                                }
                            }
                        },
                        successPage: {
                            tabName: "Success Page",
                            title: "Success Page",
                            description: "In certain cases, the user will be presented with this page while waiting to be redirected to their next step.",
                            inputs: {
                                showSuccessPage: {
                                    label: "Show Success Page",
                                    tooltip: "Enables/disables the success page"
                                },
                                successPageHeader: {
                                    label: "Success Page Header",
                                    tooltip: "The title once the process is done"
                                },
                                successText: {
                                    label: "Success Text",
                                    tooltip: "The success message once the process is done"
                                },
                                showLoadingIndicator: {
                                    label: "Show Loading Indicator while waiting for redirect",
                                    tooltip: "Enables/disables a loading indicator (below the message)"
                                }
                            }
                        },
                        errorPage: {
                            tabName: "Error Page",
                            title: "Error Page",
                            description: "If an error occurs during the verification process, this page will be shown.",
                            inputs: {
                                errorPageHeader: {
                                    label: "Error Page Header",
                                    tooltip: "The title of the error page"
                                },
                                errorMessage: {
                                    label: "Error Message",
                                    tooltip: "The message that appears when an error occurs"
                                },
                                errorDescriptionLabel: {
                                    label: "Error Description Label"
                                },
                                referenceIdLabel: {
                                    label: "Reference Id Label"
                                }
                            }
                        },
                        policyRetryMessage: {
                            tabName: "Policy Retry Message",
                            title: "Policy Retry Message",
                            description: "If the user fails to pass the policy check, they will be shown this message.",
                            inputs: {
                                policyRetryMessage: {
                                    label: "Policy Retry Message",
                                    defaultLabel: "Default Policy Retry Message",
                                    tooltip: "The message that appears when the user fails to pass the policy check"
                                },
                                policyRetryMessageDescription: {
                                    label: "Error Description Label"
                                },
                                borderWidth: {
                                    label: "Border Width",
                                    tooltip: "The width of the retry message border"
                                },
                                borderRadius: {
                                    label: "Border Radius",
                                    tooltip: "The retry message border radius"
                                },
                                borderColor: {
                                    label: "Border Color",
                                    tooltip: "The color of the Border used throughout the application"
                                },
                                backgroundColor: {
                                    label: "Background Color",
                                    tooltip: "The retry message section background color"
                                },

                            }
                        },
                        customCss: {
                            tabName: "Custom CSS",
                            title: "Custom CSS",
                            description: "You can apply global css styles here",
                            inputs: {
                                useCustomCss: {
                                    label: "Use Custom Global CSS Styles",
                                    tooltip: "Enables/disables the ability to globally apply custom CSS to the application"
                                },
                                customCss: {
                                    label: "Custom CSS",
                                    tooltip: "If you want to apply a style globally, you can set the CSS style here"
                                }
                            }
                        },
                        messaging: {
                            tabName: "Messaging",
                            title: "Messaging",
                            description: "You can customize the messages that get sent to your users on the page",
                            inputs: {
                                templateType: {
                                    label: "Select Template Type",
                                    tooltip: "Select the template type that you would like to configure for your service."
                                },
                                emailTemplate: {
                                    label: "Select the email template",
                                    tooltip: `Select the desired template to use for this service. To create a new template, go to the Messaging Templates page and click "Add a new Messaging Template". After the template has been created, it will be available in this dropdown.`
                                },
                                smsTemplate: {
                                    label: "Select the SMS template",
                                    tooltip: `Select the desired template to use for this service. To create a new template, go to the Messaging Templates page and click "Add a new Messaging Template". After the template has been created, it will be available in this dropdown.`
                                },
                                selectTemplate: {
                                    label: (templateType: string) => {
                                        if (templateType === MessagingTemplateTypes.DCUI_EMAIL || templateType === MessagingTemplateTypes.PIN_EMAIL) {
                                            return `Select the email template (${templateType})`;
                                        } else {
                                            return `Select the SMS template (${templateType})`;
                                        }
                                    },
                                    tooltip: `Select the desired template to use for this service. To create a new template, go to the Messaging Templates page and click "Add a new Messaging Template". After the template has been created, it will be available in this dropdown.`
                                },
                                previewTemplate: {
                                    label: "Preview Template"
                                },
                                dcuiEmailSubject: {
                                    label: "Email Subject"
                                },
                                dcuiEmailSender: {
                                    label: "Email sender",
                                    tooltip: "To use a different email sender than is displayed here, contact your IDDataweb account manager."
                                },
                                template: {
                                    tooltip: "This field will allow the user to copy and paste the HTML template for the desired template structure, there are no validations around the validity of the HTML, the user is responsible for validating the input before pasting. to learn more click on the link documentation"
                                }
                            },
                            sections: {
                                emailFromAddress: {
                                    title: "Email From Address",
                                    inputs: {
                                        pinFromEmailAddress: {
                                            label: "PIN Email From Address",
                                            tooltip: 'The email address used to send PIN (OTP) emails. IMPORTANT: updating this requires your email address to be "greenlisted" with IDW first. Please speak to your Solutions Architect to understand the greenlisting options'
                                        },
                                        dcuiFromEmailAddress: {
                                            label: "DCUI Email From Address",
                                            tooltip: 'The email address used to send Document Capture emails. IMPORTANT: updating this requires your email address to be "greenlisted" with IDW first. Please speak to your Solutions Architect to understand the greenlisting options'
                                        }
                                    }
                                },
                                preview: {
                                    title: {
                                        label: "Preview Configuration - Messaging Template"
                                    }
                                }
                            }
                        },
                        landingPage: {
                            tabName: "Landing Page",
                            title: "Landing Page",
                            serviceDescription: "Landing Pages can only be configured from Workflow Configuration pages. You can view the configuration here, but you will not be able to update it from this page.",
                            workflowDescription: "Use this tab to configure what users see at the end of their verification process.",
                            buttons: {
                                addLandingPage: {
                                    label: (landingPageType: LandingPageTypes) => `Add ${landingPageType}`
                                }
                            },
                            inputs: {
                                useLandingPage: {
                                    label: "Customize Landing Page(s)",
                                    tooltip: ""
                                },
                                landingPage: {
                                    label: "Landing Page Name"
                                },
                                approveMessageHTML: {
                                    label: "Approve Message HTML",
                                    tooltip: "Customize the message that appears when a user is successfully verified"
                                },
                                denyMessageHTML: {
                                    label: "Deny Message HTML",
                                    tooltip: "Customize the message that appears when a user is denied"
                                },
                                showAsiLabel: {
                                    label: "Show Transaction Label",
                                    tooltip: "Enables/disables the display of the Transaction ID (ASI) on the page"
                                },
                                asiLabel: {
                                    label: "Transaction Name",
                                    tooltip: "Customize the label that appears before the Transaction ID (ASI)"
                                }
                            },
                            sections: {
                                customLandingPage: {
                                    title: "Custom Landing Pages",
                                    description: "Landing pages that show up under this section lead to customizable pages the user will see at the end of their verification process.",
                                    noneAdded: "You have not added any Custom Landing Pages"
                                },
                                staticLandingPages: {
                                    title: "Static Landing Pages",
                                    description: "Landing pages that show up under this section lead to pages that display the detailed results of the transaction.",
                                    noneAdded: "You have not added any Static Landing Pages"
                                },
                                customerRedirectUrls: {
                                    title: "Customer Redirect URLs",
                                    description: "Redirect URLs that show up under this section lead to non IDDataweb sites. They are not able to be previewed.",
                                    noneAdded: "You have not added any Customer Redirect URLs"
                                }
                            }
                        },
                        asyncWaitingPage: {
                            tabName: "Async Waiting Page",
                            title: "Async Waiting Page",
                            description: "Use this tab to customize the page that appears during an asynchronous mobile flow"
                        },
                        mobileCompletePage: {
                            tabName: "Mobile Complete Page",
                            title: "Mobile Complete Page",
                            description: "Use this tab to customize the page that appears after an image capture step has been performed",
                            inputs: {
                                mobileCompleteTitle: {
                                    label: "Mobile Complete Title",
                                    tooltip: "The title that appears on the Mobile Complete Page"
                                },
                                successMessage: {
                                    label: "Success Message",
                                    tooltip: "The message that appears when the mobile capture step has succeeded"
                                },
                                errorMessage: {
                                    label: "Error Message",
                                    tooltip: "The message that appears when the mobile capture step has failed"
                                }
                            }
                        },
                        kbaForm: {
                            tabName: "KBA Form",
                            title: "KBA Form",
                            description: "Use this tab to customize the content on the KBA step of the verification process",
                            inputs: {
                                helloMessage: {
                                    label: "Instructional Message",
                                    tooltip: "The message that appears when the KBA step is presented to the user for the first time"
                                },
                                retryMessage: {
                                    label: "Retry Message",
                                    tooltip: "The message that appears after a failed first attempt of verifying identity through KBA"
                                }
                            }
                        }
                    }
                },
                policies: {
                    tabName: "Policies",
                    sections: {
                        policies: {
                            title: "Policies",
                            inputs: {
                                selectPolicyOption: {
                                    label: "Select a Policy Option"
                                }
                            }
                        },
                        details: {
                            title: "Policy Details",
                            obligationWarningMessage: "The selected Obligation API key belongs to a different workflow or is inactive. Please select a valid Obligation API key from the dropdown.",
                            sections: {
                                alwaysObligate: {
                                    invalidStepUpApiKey: "The selected Step Up Service API Key does not belong to your Relying Party. Please select a Step Up Service API Key that belongs to your Relying Party.",
                                    inputs: {
                                        stepUpApiKey: {
                                            label: "Select a Step Up Service API Key"
                                        }
                                    }
                                },
                                retryErrorMessage: {
                                    errors: {
                                        retryMessage: {
                                            noRetryMessage: "Retry Message is Required"
                                        }
                                    }
                                },
                                trustScore: {
                                    invalidStepUpApiKey: "The selected Step Up Service API Key does not belong to your Relying Party. Please select a Step Up Service API Key that belongs to your Relying Party.",
                                    inputs: {
                                        stepUpApiKey: {
                                            label: "Select a Step Up Service API Key"
                                        },
                                        enableStepUp: {
                                            label: "Enable Step Up"
                                        }
                                    },
                                    errors: {
                                        stepUpApiKey: {
                                            noStepUpKey: "Select a service to step up to."
                                        }
                                    },
                                    stepUpEnabledInstruction: "Select both a step up and pass score minimum values",
                                    stepUpDisabledInstruction: "Select a pass score minimum value"
                                }
                            }
                        },
                        editor: {
                            title: "Policy Editor",
                            description: "Define one or many rules which lead to corresponding actions",
                            sections: {
                                rules: {
                                    title: "Rules",
                                    description: "Defines your policy. Rules are split up into three categories: Deny, Approve, and Obligate. Policies first check Deny rules, then Approve rules, then Obligate Rules. If none of the rules match, the Default Rule behavior is used.",
                                    noRulesMessage: (isDisabled: boolean) => `No custom rules have been added.${!isDisabled ? " Click Add Rule to add one now." : ""}`,
                                    noDecisionActionTypeRulesMessage: (decisionActionType: PolicyDecisionActionTypes) => `No ${decisionActionType} rules have been added.`,
                                    buttons: {
                                        addRule: {
                                            label: "Add Rule"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                federatedIdp: {
                    tabName: "Federated IDP",
                    subTabs: {
                        identityProviders: {
                            tabName: "Identity Providers",
                            title: "Federated IDP - Identity Providers",
                            description: "Choose your Identity Provider(s)",
                            noIdentityProvidersMessage: (isDisabled: boolean) => `No Identity Providers have been added.${!isDisabled ? " Please select at least one valid identity provider in order to properly configure the Adaptive Single Sign On capability." : ""}`,
                            buttons: {
                                addIdentityProvider: {
                                    label: "Add Identity Provider"
                                }
                            }
                        },
                        reverification: {
                            tabName: "Reverification",
                            title: "Federated IDP - Reverification",
                            description: "Choose the frequency of reverification of assertions for each service"
                        },
                        properties: {
                            tabName: "Properties",
                            title: "Federated IDP - Properties",
                            description: "Properties that apply to Federated IDPs",
                            noPropertiesMessage: (isDisabled: boolean) => `No Federated IDP properties have been added.${!isDisabled ? " Click Add Property to add one now." : ""}`,
                            allPropertiesMessage: "All of the available Federated IDP properties have been added.",
                            buttons: {
                                addProperty: {
                                    label: "Add Property"
                                }
                            }
                        }
                    }
                }
            }
        },
        verificationServices: {
            header: "VERIFICATION SERVICES",
            headerButton: "Add Verification Service",
            errors: {
                invalidConfiguration: {
                    title: "Service Configuration Error",
                    message: "There was an error retrieving the service data needed. Please try again or contact support."
                }
            },
            filters: {
                showArchivedServices: {
                    label: "Show Only Archived Services"
                }
            },
            dropdownItems: {
                open: {
                    label: "Open Verification Service Details"
                }
            }
        },
        verificationTransactionDetails: {
            header: "VERIFICATION DETAILS",
            headerButton: "Export to PDF",
            labels: {
                verificationServiceName: {
                    label: "Verification Service Name"
                },
                apiKey: {
                    label: "API Key"
                },
                transactionId: {
                    label: "Transaction ID (ASI)"
                },
                relyingParty: {
                    label: "Relying Party"
                },
                userMBUN: {
                    label: "User MBUN"
                },
                userCredential: {
                    label: "User Credential"
                },
                sessionKey: {
                    label: "Session Key"
                },
                appId: {
                    label: "App ID"
                },
                workflow: {
                    label: "Workflow"
                },
                country: {
                    label: "Country"
                }
            },
            cards: {
                policyDecision: {
                    title: "Policy Decision"
                },
                idwTrustScore: {
                    title: "IDW Trust Score"
                },
                passedAssertions: {
                    title: "Passed Assertions"
                },
                failedAssertions: {
                    title: "Failed Assertions"
                },
                unverifiedAssertions: {
                    title: "Unverified Assertions"
                },
                warnAssertions: {
                    title: "Warn Assertions"
                }

            }
        },
        verificationTransactions: {
            header: "VERIFICATION REPORT",
            searchForm: {
                filters: {
                    appId: {
                        label: "App ID"
                    },
                    assertions: {
                        label: "Assertions"
                    },
                    claimStatus: {
                        label: "Claim Status"
                    },
                    sessionKey: {
                        label: "Session Key"
                    },
                    transactionId: {
                        label: "Transaction ID (ASI)"
                    },
                    userCredential: {
                        label: "User Credential"
                    },
                    includeArchivedServicesAndWorkflows: {
                        label: "Include Archived Services and Workflows"
                    }
                }
            },
            transactionLimitMessage: "Your current search query has exceeded the maximum number of results allowed. Please use the search filters to modify your query to return a smaller set of results."
        },
        workflowDetails: {
            modals: {
                addServiceToWorkflow: {
                    title: "Add Verification Service to Workflow",
                    description: "This action will add a Verification Service to the Workflow. When you have finished configuring the Verification Service, Submit the Change Request for review to continue the process. You may also Cancel the Change Request at any time prior to deployment.",
                }
            },
            buttons: {
                addService: {
                    label: "Add Service to Workflow"
                }
            },
            header: "MANAGE WORKFLOW SETTINGS",
            inputs: {
                language: {
                    label: "Language",
                    tooltip: "This dropdown contains all of the languages that have been configured for your workflow. Use it to choose which language to preview and configure."
                }
            },
            tabs: {
                general: {
                    tabName: "General",
                    subTabs: {
                        basicInfo: {
                            tabName: "Basic Info",
                            title: "General Settings - Basic Info",
                            buttons: {
                                addRedirectUrl: {
                                    label: "Add Redirect URL"
                                }
                            },
                            inputs: {
                                workflowName: {
                                    label: "Workflow Name",
                                    placeholder: "Enter a name for the workflow"
                                },
                                apiKey: {
                                    label: "Primary Service API Key",
                                    placeholder: "Provide an API key"
                                },
                                sharedSecret: {
                                    label: "Shared Secret",
                                    placeholder: "Provide a Shared Secret"
                                }
                            }
                        },
                        translation: {
                            tabName: "Translation",
                            title: "General Settings - Translation",
                            description: `Enable translation to support multi language content on your workflow, after enabling this feature navigate to theming tab and document capture theming tab to translate the content to your satisfaction. Our default content is automatically translated to all countries available in the language dropdown.`,
                            inputs: {
                                enableTranslation: {
                                    label: "Enable Translation"
                                },
                                usePrimaryLanguageByDefault: {
                                    label: "Default UI to Primary Language",
                                    tooltip: "Enabling this toggle will cause the UI Applications to render with the primary language selected by default"
                                },
                                languagesOrder: {
                                    title: "Languages Order",
                                    description: "Drag and Drop the languages in the list below to update the order that they appear to the user for the Language Selector in AXNUI"
                                },
                                languages: {
                                    label: "Supported Languages",
                                    required: "Please select at least one language",
                                    confirmLanguageDeletion: {
                                        title: "Confirm Language Deletion",
                                        confirmButtonText: "Confirm",
                                        warningMessage: (languageLabel: string) => `You are about to remove the language ${languageLabel} from your list. By removing this language you will permanently remove all the customized text for it`
                                    }
                                }
                            }
                        }
                    }
                },
                visualization: {
                    tabName: "Visualization",
                    description: "Right click on any of the services or policy decisions in the visualization to display a list of actions."
                },
                attributes: {
                    tabName: "Attributes"
                }
            }
        },
        workflowReport: {
            header: "WORKFLOW REPORT",
            searchForm: {
                sixMonthMessage: "Summary data will be available, but raw transaction info is not available past 6 months",
                filters: {
                    appId: {
                        label: "App ID"
                    },
                    country: {
                        label: "Country"
                    },
                    includeArchivedWorkflows: {
                        label: "Include Archived Workflows"
                    }
                }
            },
            sections: {
                passRates: {
                    title: "Unique Users Pass Rates",
                    description: (
                        total: number,
                        approved: number,
                        denied: number
                    ) => {
                        return `The view is a representation of the decision outcomes for unique users. Of the <b>${total} unique user${total !== 1 ? "s" : ""}</b> who completed the process, <b>${approved} ${approved !== 1 ? "were" : "was"} approved</b>, and <b>${denied} ${denied !== 1 ? "were" : "was"} denied.</b>`;
                    },
                    tooltip: `These graphs show the result of users who completed the process. If a user was approved across any attempt, they will be counted towards "approved." These graphs help visualize the final outcome of the workflow`
                },
                completionRates: {
                    title: "Unique Users Completion Rates",
                    description: (
                        total: number,
                        complete: number
                    ) => {
                        return `The view is a representation of the decision outcomes for unique users. Of the <b>${total} unique user${total !== 1 ? "s" : ""}</b> who started the process, <b>${complete} completed all steps.</b>`
                    },
                    tooltip: `These graphs show the result of all users who attempted the process. If a user was approved or denied across any attempt, they will be counted towards "complete." These graphs help visualize the users' ability and willingness to complete the workflow`
                },
                volumesByAppID: {
                    title: "Volume By App ID",
                    description: (
                        transactionCount: number,
                        userCount: number
                    ) => {
                        return `This workflow has seen a total of <b>${transactionCount} transaction${transactionCount !== 1 ? "s" : ""}</b> for <b>${userCount} user${userCount !== 1 ? "s" : ""}</b> over this time range. Below is the breakdown of # of transactions per application.`
                    }
                },
                volumesByCountry: {
                    title: "Volume By Country",
                    description: `For the same number of users, below are the transactions seen per country over this time range.`
                },
                fraud: {
                    title: "Risky Transactions",
                    headerLink: "More Details",
                    description: (
                        total: number,
                        riskCount: number
                    ) => {
                        return `For the <b>${total} total transaction${total !== 1 ? "s" : ""}</b>, there ${riskCount !== 1 ? "were" : "was"} <b>${riskCount} risk signal${riskCount !== 1 ? "s" : ""} detected.</b>`
                    }
                },
                stepByStep: {
                    title: "Overall Transactions Step by Step Breakdown",
                    description: (
                        stepCount: number,
                        completeApprovedCount: number,
                        completeDeniedCount: number,
                        proceedPassCount: number,
                        proceedFailCount: number,
                        abandonedCount: number
                    ) => {
                        return `The view is the representation of a total transactions broken down by the workflow steps. <br><br/>
                        
                            For the <b>${stepCount} step${stepCount !== 1 ? "s" : ""}</b>,
                            there ${completeApprovedCount !== 1 ? "were" : "was"}: <br>
                            <b>${completeApprovedCount} - Complete - Approved</b> transaction${completeApprovedCount !== 1 ? "s" : ""},<br>
                            <b>${completeDeniedCount} - Complete - Denied</b> transaction${completeDeniedCount !== 1 ? "s" : ""},<br>
                            <b>${abandonedCount} - Abandoned</b> transaction${abandonedCount !== 1 ? "s" : ""},<br>
                            <b>${proceedPassCount} - total Proceed - Pass</b> on step${proceedPassCount !== 1 ? "s" : ""},<br>
                            and <b>${proceedFailCount} - total Proceed - Fail</b> on step${proceedFailCount !== 1 ? "s" : ""}.
                        `;
                    },
                    tooltip: `This chart shows a combined approval & completion rate on a step-by-step basis. High rates of "Complete - Approved" and "Proceed - Pass" are indicative of a healthy workflow`
                }
            }
        },
        workflows: {
            header: "WORKFLOWS",
            headerButton: "Add Verification Workflow",
            headerButtonDisabledText: "You have reached the maximum number of workflows allowed for your current subscription tier. To continue adding more workflows, please delete unused workflows, upgrade your subscription, or contact support for further assistance.",
            filters: {
                showArchivedWorkflows: {
                    label: "Show Only Archived Workflows"
                }
            },
            errors: {
                noApiKeysConfigured: {
                    title: "Workflow Configuration Error",
                    message: "This workflow does not have any API keys configured."
                }
            },
            dropdownItems: {
                open: {
                    label: "Open Workflow Details"
                }
            }
        },
        workflowTemplates: {
            header: "WORKFLOW TEMPLATES",
            headerButton: "Add Workflow Template"
        },
        workflowTemplateDetails: {
            title: "WORKFLOW TEMPLATE DETAILS",
            tabs: {
                metadata: {
                    tabName: "Metadata",
                    header: "METADATA",
                    buttons: {
                        updateTemplateJSON: {
                            label: "Update Template JSON"
                        }
                    },
                    inputs: {
                        name: {
                            label: "Name",
                            placeholder: "Enter a name for the workflow template"
                        },
                        description: {
                            label: "Description",
                            placeholder: "Enter a description for the workflow template"
                        },
                        descriptionURL: {
                            label: "Description URL",
                            placeholder: "Enter a URL which points to a documentation page describing the template"
                        },
                        templateJSON: {
                            label: "Template JSON",
                            placeholder: "Add your template here"
                        },
                        status: {
                            label: "Status"
                        }
                    }
                },
                policyConfigs: {
                    tabName: "Visualization",
                    header: "VISUALIZATION",
                    description: "Right click on any of the services or policy decisions in the visualization to display a list of actions."
                },
                profiles: {
                    tabName: "Profiles",
                    header: "PROFILES",
                    inputs: {
                        name: "Profile Name"
                    }
                },
                services: {
                    tabName: "Services",
                    header: "SERVICES"
                }
            }
        },
        workflowUsageDetails: {
            header: "WORKFLOW SERVICES REPORT"
        }
    },
    pagination: {
        first: "First",
        last: "Last",
        previousPage: "Previous Page",
        nextPage: "Next Page",
        limit: "Limit:",
        results: (start: number, end: number, size: number) => `Results: ${start} - ${end} of ${size}`
    },
    requests: {
        accessDenied: {
            error: {
                title: "Access Permission Error",
                message: "You do not have the permission necessary to perform the given action. If you believe you should have access, please contact your organization administrator"
            }
        },
        archiveVerificationService: {
            error: {
                title: "Verification Service Archive Error",
                message: "An error occurred while archiving the verification service"
            },
            success: {
                title: "Verification Service Archive Success",
                message: "The verification service was successfully archived"
            }
        },
        archiveWorkflow: {
            error: {
                title: "Workflow Archive Error",
                message: "An error occurred while archiving the workflow"
            },
            success: {
                title: "Workflow Archive Success",
                message: "The workflow was successfully archived"
            }
        },
        authenticateUser: {
            error: {
                title: "Authenticate User Error",
                message: "An error occurred while authenticating your user"
            }
        },
        configureCorporateLogin: {
            error: {
                title: "Configure Corporate Login Failed",
                message: "An error occurred while configuring a corporate login"
            },
            success: {
                title: "Corporate Login Successfully Configured",
                message: "A Corporate Login has been successfully configured"
            }
        },
        resetAxnAdminUserPassword: {
            error: {
                title: "Reset User Password Failed",
                message: "An error occurred while resetting the user password"
            },
            success: {
                title: "Reset User Password processed",
                message: "An email has successfully been sent to the provided email address to allow the user to reset their password"
            }
        },
        createAttributeLabel: {
            error: {
                title: "Attribute Label Creation Failed",
                message: "An error occurred while creating the attribute label"
            },
            success: {
                title: "Attribute Label Created",
                message: "The attribute label was successfully created"
            }
        },
        createIdentityProvider: {
            error: {
                title: "Identity Provider Creation Failed",
                message: "An error occurred while creating the identity provider"
            },
            success: {
                title: "Identity Provider Created",
                message: "The identity provider was successfully created"
            }
        },
        createIdentityProviderChangeRequest: {
            error: {
                title: "Identity Provider Change Request Error",
                message: "An error occurred while creating a change request for the identity provider"
            },
            success: {
                title: "Identity Provider Change Request Created",
                message: "The identity provider change request was successfully created"
            }
        },
        createMessagingTemplate: {
            error: {
                title: "Messaging Template Creation Failed",
                message: "An error occurred while creating the messaging template"
            },
            success: {
                title: "Messaging Template Created",
                message: "The messaging template was successfully created"
            }
        },
        createEmailTemplate: {
            error: {
                title: "Email Template Creation Failed",
                message: "An error occurred while creating the Email template"
            },
            success: {
                title: "Email Template Created",
                message: "The Email template was successfully created"
            }
        },
        createUser: {
            error: {
                title: "User Creation Failed",
                message: "An error occurred while creating the user"
            },
            success: {
                title: "User Created",
                message: "The user was successfully created"
            },
        },
        createVerificationServiceChangeRequest: {
            error: {
                title: "Verification Service Change Request Error",
                message: "An error occurred while starting a change request for the verification service"
            },
            success: {
                title: "Verification Service Change Request Started",
                message: "The verification service change request was successfully started"
            }
        },
        createWorkflowChangeRequest: {
            error: {
                title: "Verification Workflow Change Request Error",
                message: "An error occurred while creating a change request for the verification workflow"
            },
            success: {
                title: "Verification Workflow Change Request Started",
                message: "The verification workflow change request was successfully started"
            }
        },
        createOrganization: {
            error: {
                title: "Organization Creation Failed",
                message: "An error occurred while creating the organization"
            },
            success: {
                title: "Organization Created",
                message: "The organization was successfully created"
            }
        },
        createPolicyComponent: {
            success: {
                title: "Policy Component Created",
                message: "The policy component was successfully created"
            },
            error: {
                title: "Policy Component Creation Failed",
                message: "An error occurred while creating the policy component"
            }
        },
        createRelyingParty: {
            error: {
                title: "Relying Party Creation Failed",
                message: "An error occurred while creating the relying party"
            },
            success: {
                title: "Relying Party Created",
                message: "The relying party was successfully created"
            }
        },
        createSecurityRule: {
            error: {
                title: "Security Rule Creation Failed",
                message: "An error occurred while creating the security rule"
            },
            success: {
                title: "Security Rule Created",
                message: "The security rule was successfully created"
            }
        },
        createServiceTemplate: {
            error: {
                title: "Service Template Creation Failed",
                message: "An error occurred while creating the service template"
            },
            success: {
                title: "Service Template Created",
                message: "The service template was successfully created"
            }
        },
        createVerificationService: {
            error: {
                title: "Verification Service Creation Failed",
                message: "An error occurred while creating the verification service"
            },
            success: {
                title: "Verification Service Created",
                message: "The verification service was successfully created"
            }
        },
        createWorkflow: {
            error: {
                title: "Workflow Creation Failed",
                message: "An error occurred while creating the workflow"
            },
            success: {
                title: "Workflow Created",
                message: "The workflow was successfully created"
            }
        },
        createWorkflowTemplate: {
            error: {
                title: "Workflow Template Creation Failed",
                message: "An error occurred while creating the workflow template"
            },
            success: {
                title: "Workflow Template Created",
                message: "The workflow template was successfully created"
            }
        },
        deleteOrganization: {
            error: {
                title: "Delete Organization Error",
                message: "An error occurred while deleting the organization"
            },
            success: {
                title: "Delete Organization Success",
                message: "The organization was successfully deleted"
            }
        },
        deleteWorkflow: {
            error: {
                title: "Workflow Delete Error",
                message: "An error occurred while deleting the workflow"
            },
            success: {
                title: "Workflow Delete Success",
                message: "The workflow was successfully deleted"
            }
        },
        deleteVerificationService: {
            error: {
                title: "Verification Service Delete Error",
                message: "An error occurred while deleting the verification service"
            },
            success: {
                title: "Verification Service Delete Success",
                message: "The verification service was successfully deleted"
            }
        },
        deployVerificationServiceChangeRequest: {
            success: {
                title: "Verification Service Deployed",
                message: "The verification service has been successfully deployed"
            }
        },
        deployWorkflowChangeRequest: {
            success: {
                title: "Verification Workflow Deployed",
                message: "The verification workflow has been successfully deployed"
            }
        },
        exportAssertionFraud: {
            error: {
                title: "Export Fraud Report Error",
                message: "An error occurred while loading the required data to export the Fraud Report"
            }
        },
        exportIdentityProviderConfiguration: {
            error: {
                title: "Export IDP Configuration Error",
                message: "An error occurred while loading the required data to export the IDP configuration"
            }
        },
        exportVerificationServiceConfiguration: {
            error: {
                title: "Export Verification Service Error",
                message: "An error occurred while loading the required data to export the Verfication Service configuration"
            }
        },
        exportWorkflowConfiguration: {
            error: {
                title: "Export Workflow Error",
                message: "An error occurred while loading the required data to export the Workflow configuration"
            }
        },
        getActivityLogs: {
            error: {
                title: "Activity Logs Fetch Error",
                message: "An error occurred while loading the activity logs"
            }
        },
        getAdaptiveAuthenticationResults: {
            error: {
                title: "Adaptive Authentication Report Fetch Error",
                message: "An error occurred while loading the adaptive authentication report"
            }
        },
        getAlertEvents: {
            error: {
                title: "Alert Events Fetch Error",
                message: "An error occurred while loading the alert events"
            }
        },
        getAssertionFraud: {
            error: {
                title: "Assertion Fraud Report Fetch Error",
                message: "An error occurred while loading the assertion fraud report"
            }
        },
        getAttributeLabelDetails: {
            error: {
                title: "Attribute Label Details Fetch Error",
                message: "An error occurred while loading the attribute label details."
            }
        },
        getAttributeLabels: {
            error: {
                title: "Attribute Labels Fetch Error",
                message: "An error occurred while loading the attribute labels"
            }
        },
        getAxnAdminAvailableUserOrganizationProperties: {
            error: {
                title: "AXN Admin Available User Organizatopn Properties Fetch Error",
                message: "An error occurred while loading the AXN Admin Available User Organization Properties"
            }
        },
        getAxnAdminAvailableUserRPProperties: {
            error: {
                title: "AXN Admin Available User RP Properties Fetch Error",
                message: "An error occurred while loading the AXN Admin Available User RP Properties"
            }
        },
        getAxnAdminUserPropertyBundles: {
            error: {
                title: "AXN Admin User Property Bundles Fetch Error",
                message: "An error occurred while loading the AXN Admin User Property Bundles"
            }
        },
        getAxnSessions: {
            error: {
                title: "AXN Sessions Fetch Error",
                message: "An error occurred while loading the AXN sessions"
            }
        },
        getAxnAdminSessions: {
            error: {
                title: "AXN Admin Sessions Fetch Error",
                message: "An error occurred while loading the AXN Admin sessions"
            }
        },
        getDashboardSummary: {
            error: {
                title: "Dashboard Summary Fetch Error",
                message: "An error occurred while loading the dashboard summary data"
            }
        },
        getDashboardVerificationCounts: {
            error: {
                title: "Dashboard Verification Counts Fetch Error",
                message: "An error occurred while loading the dashboard verification counts"
            }
        },
        getDashboardVerificationServices: {
            error: {
                title: "Dashboard Verification Services Fetch Error",
                message: "An error occurred while loading the dashboard verification services"
            }
        },
        getDashboardVerificationTransactions: {
            error: {
                title: "Dashboard Verification Transactions Fetch Error",
                message: "An error occurred while loading the dashboard verification transactions"
            }
        },
        getIdentityProviderConfigurations: {
            error: {
                title: "Identity Providers Fetch Error",
                message: "An error occurred while loading the identity providers"
            }
        },
        getIdentityProviderDetailsAxn: {
            error: {
                title: "Identity Provider Details Fetch Error",
                message: "An error occurred while loading the identity provider details"
            }
        },
        getMessagingTemplateDetails: {
            error: {
                title: "Messaging Template Details Fetch Error",
                message: "An error occurred while loading the messaging template details"
            }
        },
        getMessagingTemplates: {
            error: {
                title: "Messaging Templates Fetch Error",
                message: "An error occurred while loading the messaging templates"
            }
        },
        getEmailTemplateDetails: {
            error: {
                title: "Email Template Details Fetch Error",
                message: "An error occurred while loading the email template details"
            }
        },
        getEmailTemplates: {
            error: {
                title: "Email Templates Fetch Error",
                message: "An error occurred while loading the email templates"
            }
        },

        getMonthlyUsers: {
            error: {
                title: "Monthly Users Report Fetch Error",
                message: "An error occurred while loading the monthly users report"
            }
        },
        getOrganizationDetails: {
            error: {
                title: "Organization Details Fetch Error",
                message: "An error occurred while loading the organization details"
            }
        },
        getOrganizationInvitationDetails: {
            error: {
                title: "Invitation Details Fetch Error",
                message: "An error occurred while loading the invitation details"
            }
        },
        getOrganizationInvitations: {
            error: {
                title: "Organization Invitations Fetch Error",
                message: "An error occurred while loading the organization invitations"
            }
        },
        getOrganizations: {
            error: {
                title: "Organizations Fetch Error",
                message: "An error occurred while loading the organizations"
            }
        },
        archiveOrganization: {
            error: {
                title: "Inactivate Organization Error",
                message: "An error occurred while inactivating the organization"
            },
            success: {
                title: "Inactivate Organization Success",
                message: "The organization was successfully inactivated"
            }
        },
        getOrganizationUserDetails: {
            error: {
                title: "Organization User Fetch Error",
                message: "An error occurred while loading the organization user"
            }
        },
        getOrganizationUsers: {
            error: {
                title: "Organization Users Fetch Error",
                message: "An error occurred while loading the organization users"
            }
        },
        getServiceTemplates: {
            error: {
                title: "Service Templates Fetch Error",
                message: "An error occurred while loading the service templates"
            }
        },
        archiveOrganizationUser: {
            error: {
                title: "Inactivate Organization User Error",
                message: "An error occurred while inactivating the user"
            },
            success: {
                title: "Inactivate User Success",
                message: "The user was successfully inactivated"
            }
        },
        deleteOrganizationUser: {
            error: {
                title: "Delete Organization User Error",
                message: "An error occurred while deleting the user"
            },
            success: {
                title: "Delete User Success",
                message: "The user was successfully deleted"
            }
        },
        deleteRelyingParty: {
            error: {
                title: "Delete Relying Party Error",
                message: "An error occurred while deleting the relying party"
            },
            success: {
                title: "Delete Relying Party Success",
                message: "The relying party was successfully deleted"
            }
        },
        restoreOrganizationUser: {
            error: {
                title: "Restore Organization User Error",
                message: "An error occurred while restoring the user"
            },
            success: {
                title: "Restore User Success",
                message: "The user was successfully restored"
            }
        },
        getPolicyComponents: {
            error: {
                title: "Policy Components Fetch Error",
                message: "An error occurred while loading the policy components"
            }
        },
        getRelyingParties: {
            error: {
                title: "Relying Parties Fetch Error",
                message: "An error occurred while loading the relying parties"
            }
        },
        archiveRelyingParty: {
            error: {
                title: "Inactivate Relying Party Error",
                message: "An error occurred while inactivating the relying party"
            },
            success: {
                title: "Inactivate Relying Party Success",
                message: "The relying party was successfully inactivated"
            }
        },
        getRpServiceConfiguration: {
            error: {
                title: "Verification Service Fetch Error",
                message: "An error occurred while loading the verification service"
            }
        },
        getWorkflowAppliedProfile: {
            error: {
                title: "Workflow Applied Profile Fetch Error",
                message: "An error occurred while loading the applied profile of your selected workflow"
            }
        },
        getSecurityRules: {
            error: {
                title: "Security Rules Fetch Error",
                message: "An error occurred while loading the security rules"
            }
        },
        getServiceAssertionPerformance: {
            error: {
                title: "Service Assertion Performance Report Fetch Error",
                message: "An error occurred while loading the service assertion performance report"
            }
        },
        getServiceAssertionPerformanceComparison: {
            error: {
                title: "Service Assertion Performance Comparison Report Fetch Error",
                message: "An error occurred while loading the service assertion performance comparison report"
            }
        },
        getServiceTemplateDetails: {
            error: {
                title: "Service Template Details Fetch Error",
                message: "An error occurred while loading the service template details"
            }
        },
        getVerificationServiceDetails: {
            error: {
                title: "Verification Service Details Fetch Error",
                message: "An error occurred while loading the verification service details"
            }
        },
        getVerificationServiceConfigurations: {
            error: {
                title: "Verification Services Fetch Error",
                message: "An error occurred while loading the verification services"
            }
        },
        getVerificationTransactionDetails: {
            error: {
                title: "Transaction Details Fetch Error",
                message: "An error occurred while loading the transaction details data"
            }
        },
        getVerificationTransactions: {
            error: {
                title: "Transactions Fetch Error",
                message: "An error occurred while loading the transactions data"
            }
        },
        getVerificationTransactionsSummary: {
            error: {
                title: "Transactions Summary Fetch Error",
                message: "An error occurred while loading the transactions summary data"
            }
        },
        getVerificationUrl: {
            error: {
                title: "Verification URL Fetch Error",
                message: "An error occurred while generating the verification service URL"
            }
        },
        getWorkflowConfigurations: {
            error: {
                title: "Workflow Configurations Fetch Error",
                message: "An error occurred while loading the workflow data"
            }
        },
        getWorkflowTemplates: {
            error: {
                title: "Workflow Templates Fetch Error",
                message: "An error occurred while loading the workflow templates"
            }
        },
        getWorkflowTemplateDetails: {
            error: {
                title: "Workflow Template Details Fetch Error",
                message: "An error occurred while loading the workflow template details"
            }
        },
        getWorkflowDetails: {
            error: {
                title: "Verification Workflow Details Fetch Error",
                message: "An error occurred while loading the verification workflow details"
            }
        },
        getWorkflowTemplate: {
            error: {
                title: "Workflow Template Fetch Error",
                message: "An error occurred while loading the workflow template details"
            }
        },
        getWorkflowReportPassRates: {
            error: {
                title: "Workflow Report Pass Rates Fetch Error",
                message: "An error occurred while loading the data for the pass rates graph"
            }
        },
        getWorkflowReportPassRatesOverTime: {
            error: {
                title: "Workflow Report Pass Rates Over Time Fetch Error",
                message: "An error occurred while loading the data for the pass rates over time graph"
            }
        },
        getWorkflowReportCompletionRates: {
            error: {
                title: "Workflow Report Completion Rates Fetch Error",
                message: "An error occurred while loading the data for the completion rates graph"
            }
        },
        getWorkflowReportCompletionRatesOverTime: {
            error: {
                title: "Workflow Report Completion Rates Over Time Fetch Error",
                message: "An error occurred while loading the data for the completion rates over time graph"
            }
        },
        getWorkflowReportVolumesByAppID: {
            error: {
                title: "Workflow Report Volumes By App ID Fetch Error",
                message: "An error occurred while loading the data for the Volumes By App ID graph"
            }
        },
        getWorkflowReportVolumesByCountry: {
            error: {
                title: "Workflow Report Volumes By Country Fetch Error",
                message: "An error occurred while loading the data for the Volumes By Country graph"
            }
        },
        getWorkflowReportStepByStep: {
            error: {
                title: "Workflow Report Step By Step Fetch Error",
                message: "An error occurred while loading the data for the step by step graph"
            }
        },
        getWorkflowReportFraud: {
            error: {
                title: "Workflow Report Fraud Fetch Error",
                message: "An error occurred while loading the data for the fraud graph"
            }
        },
        getWorkflowResultsDetails: {
            error: {
                title: "Workflow Results Details Fetch Error",
                message: "An error occurred while loading the workflow results details"
            }
        },
        getWorkflowSankeyResults: {
            error: {
                title: "Workflow Sankey Results Fetch Error",
                message: "An error occurred while loading the workflow sankey results"
            }
        },
        importVerificationServiceConfiguration: {
            error: {
                title: "Import Verification Service Failed",
                message: "An error occurred while importing your verification service. Please try again with a different file."
            },
            success: {
                title: "Verification Service Imported",
                message: "The verification service was successfully imported"
            }
        },
        referenceData: {
            error: {
                title: "Reference Data Fetch Error",
                message: "An error occurred while loading the required reference data."
            }
        },
        refreshAxnCache: {
            error: {
                title: "AXN Cache Refresh Error",
                message: "An error occurred while refreshing the AXN cache"
            }
        },
        refreshAxnConfig: {
            error: {
                title: "AXN Config Refresh Error",
                message: "An error occurred while refreshing the AXN config"
            }
        },
        refreshAxnAdminCache: {
            error: {
                title: "AXN Admin Cache Refresh Error",
                message: "An error occurred while refreshing the AXN Admin cache"
            }
        },
        refreshAxnAdminConfig: {
            error: {
                title: "AXN Admin Config Refresh Error",
                message: "An error occurred while refreshing the AXN Admin config"
            }
        },
        refreshAxnAdminLogging: {
            error: {
                title: "AXN Admin Logging Refresh Error",
                message: "An error occurred while refreshing the AXN Admin logging"
            }
        },
        refreshSecurityRules: {
            error: {
                title: "Security Rules Refresh Error",
                message: "An error occurred while refreshing the Security Rules"
            }
        },
        restoreOrganization: {
            error: {
                title: "Organization Restore Error",
                message: "An error occurred while restoring the organization"
            },
            success: {
                title: "Organization Restored",
                message: "The organization has been successfully restored",
            },
        },
        restoreRelyingParty: {
            error: {
                title: "Relying Party Restore Error",
                message: "An error occurred while restoring the relying party"
            },
            success: {
                title: "Relying Party Restored",
                message: "The relying party has been successfully restored"
            }
        },
        restoreVerificationService: {
            error: {
                title: "Verification Service Restore Error",
                message: "An error occurred while restoring the verification service"
            },
            success: {
                title: "Verification Service Restored",
                message: "The verification service has been successfully restored"
            }
        },
        restoreWorkflow: {
            error: {
                title: "Workflow Restore Error",
                message: "An error occurred while restoring the workflow"
            },
            success: {
                title: "Workflow Restored",
                message: "The workflow has been successfully restored"
            }
        },
        sendAxnAdminUserInvitation: {
            error: {
                title: "User Invitation Failed",
                message: "An error occurred while sending the user invitation."
            },
            success: {
                title: "User Invitation Sent",
                message: (email: string) => `An user invitation has been sent to ${email}.`
            }
        },
        updateAttributeLabel: {
            error: {
                title: "Attribute Label Update Failed",
                message: "An error occurred while updating the attribute label."
            },
            success: {
                title: "Attribute Label Updated",
                message: "The attribute label was successfully updated"
            }
        },
        updateIdentityProvider: {
            error: {
                title: "Identity Provider Update Failed",
                message: "An error occurred while updating the identity provider"
            },
            success: {
                title: "Identity Provider Updated",
                message: "The identity provider was successfully updated"
            }
        },
        updateIdentityProviderChangeRequest: {
            error: {
                title: "Identity Provider Change Request Error",
                message: "An error occurred while updating the change request for the identity provider"
            },
            success: {
                title: "Identity Provider Change Request Updated",
                message: "The identity provider change request was successfully updated"
            }
        },
        updateMessagingTemplate: {
            error: {
                title: "Messaging Template Update Failed",
                message: "An error occurred while updating the messaging template"
            },
            success: {
                title: "Messaging Template Updated",
                message: "The messaging template was successfully updated"
            }
        },
        updateEmailTemplate: {
            error: {
                title: "Email Template Update Failed",
                message: "An error occurred while updating the email template"
            },
            success: {
                title: "Email Template Updated",
                message: "The email template was successfully updated"
            }
        },
        updateOrganizationDetails: {
            error: {
                title: "Organization Update Failed",
                message: "An error occurred while updating the organization"
            },
            success: {
                title: "Organization Updated",
                message: "The organization was successfully updated"
            }
        },
        updateOrganizationInvitationDetails: {
            error: {
                title: "Invitation Update Failed",
                message: "An error occurred while updating the invitation"
            },
            success: {
                title: "Invitation Updated",
                message: "The invitation was successfully updated"
            }
        },
        updateOrganizationUserDetails: {
            error: {
                title: "User Update Failed",
                message: "An error occurred while updating the user"
            },
            success: {
                title: "User Updated",
                message: "The user was succesfully updated"
            }
        },
        updateOrganizationUsersCredentials: {
            error: {
                title: "Users Credential Update Failed",
                message: "An error occurred while updating the user"
            },
            success: {
                title: "Users credentials Updated",
                message: "The user's credentials were succesfully updated"
            }
        },
        updatePolicyComponent: {
            success: {
                title: "Policy Component Updated",
                message: "The policy component was successfully updated"
            },
            error: {
                title: "Policy Component Update Failed",
                message: "An error occurred while updating the policy component"
            }
        },
        updateRelyingParty: {
            error: {
                title: "Relying Party Update Failed",
                message: "An error occurred while updating the relying party"
            },
            success: {
                title: "Relying Party Updated",
                message: "The relying party was successfully updated"
            }
        },
        updateServiceTemplate: {
            error: {
                title: "Service Template Save Error",
                message: "An error occurred while saving the changes to the service template"
            },
            success: {
                title: "Service Template Updated",
                message: "The service template was successfully updated"
            }
        },
        updateSecurityRule: {
            error: {
                title: "Security Rule Update Failed",
                message: "An error occurred while updating the security rule"
            },
            success: {
                title: "Security Rule Updated",
                message: "The security rule was successfully updated"
            }
        },
        updateVerificationServiceChangeRequest: {
            error: {
                title: "Verification Service Change Request Error",
                message: "An error occurred while updating the change request for the verification service"
            },
            success: {
                title: "Verification Service Change Request Updated",
                message: "The verification service change request was successfully updated"
            }
        },
        updateVerificationServiceDetails: {
            error: {
                title: "Verification Service Save Error",
                message: "An error occurred while saving the changes to the verification service"
            },
            success: {
                title: "Verification Service Updated",
                message: "The verification service was successfully updated"
            }
        },
        updateWorkflowChangeRequest: {
            error: {
                title: "Verification Workflow Change Request Error",
                message: "An error occurred while updating the change request for the verification workflow"
            },
            success: {
                title: "Verification Workflow Change Request Updated",
                message: "The verification workflow change request was successfully updated"
            }
        },
        updateWorkflowDetails: {
            error: {
                title: "Verification Workflow Save Error",
                message: "An error occurred while saving the changes to the verification workflow"
            },
            success: {
                title: "Verification Workflow Updated",
                message: "The verification workflow was successfully updated"
            }
        },
        updateWorkflowTemplate: {
            error: {
                title: "Workflow Template Save Error",
                message: "An error occurred while saving the changes to the workflow template"
            },
            success: {
                title: "Workflow Template Updated",
                message: "The workflow template was successfully updated"
            }
        },
        uploadResource: {
            error: {
                title: "Resource Upload Error",
                description: "An error occurred while uploading the selected resource."
            }
        },
        validateVerificationService: {
            error: {
                title: "Verification Service Validation Failed",
                message: "An error occurred while attempting to validate the imported Verification Service. Please try again."
            }
        },
        validateVerificationWorkflow: {
            error: {
                title: "Verification Workflow Validation Failed",
                message: "An error occurred while attempting to validate the imported Verification Workflow. Please try again."
            }
        },
        getPolicyComponent: {
            error: {
                title: "Policy Component Fetch Failed",
                message: "An error occurred while loading the policy component details"
            }
        },
        getAssociatedPolicies: {
            error: {
                title: "Associated Policies Fetch Failed",
                message: "An error occurred while loading the associated policies"
            }
        }
    },
    tables: {
        activityLog: {
            columns: {
                activityType: {
                    header: "Activity Type"
                },
                action: {
                    header: "Action"
                },
                byUser: {
                    header: "By User"
                },
                description: {
                    header: "Description"
                },
                time: {
                    header: "Time"
                }
            }
        },
        adaptiveAuthentication: {
            columns: {
                date: {
                    header: "Date"
                },
                uniqueUsers: {
                    header: "Unique Users"
                },
                totalLogins: {
                    header: "Total Logins"
                },
                mfaSuppressed: {
                    header: "MFA Suppressed"
                },
                mfaNewDevicesTrusted: {
                    header: "MFA New Devices Trusted"
                },
                mfaProfilingFailed: {
                    header: "MFA Profiling Failed"
                },
                loginDenied: {
                    header: "Login Denied"
                }
            }
        },
        alertEvents: {
            columns: {
                dateTriggered: {
                    header: "Date Triggered"
                },
                alert: {
                    header: "Alert"
                },
                organization: {
                    header: "Organization"
                },
                workflow: {
                    header: "Workflow"
                },
                service: {
                    header: "Service"
                },
                credential: {
                    header: "Credential"
                },
                details: {
                    header: "Details",
                    content: "Details"
                }
            },
        },
        alertEventIncidents: {
            title: "Alert Event Incidents",
            columns: {
                dateTriggered: {
                    header: "Date"
                },
                asi: {
                    header: "ASI"
                },
                cause: {
                    header: "Cause"
                },
                workflow: {
                    header: "Workflow"
                },
                service: {
                    header: "Service"
                },
                credential: {
                    header: "Credential"
                }
            }
        },
        assertionScoreDetails: {
            title: "Assertion Score Details",
            totalPoints: (pointsEarned: number, totalPoints: number) => `Total Points: ${pointsEarned} / ${totalPoints}`,
            columns: {
                assertion: {
                    header: "Assertion"
                },
                serviceOffering: {
                    header: "Attribute Provider"
                },
                status: {
                    header: "Status"
                },
                points: {
                    header: "Points"
                }
            }
        },
        attributeLabels: {
            columns: {
                id: {
                    header: "ID"
                },
                label: {
                    header: "Label"
                },
                attributeTypeId: {
                    header: "Attribute Type ID"
                },
                attributeType: {
                    header: "Attribute Type"
                }
            }
        },
        axnAdminSessions: {
            columns: {
                userId: {
                    header: "User ID"
                },
                role: {
                    header: "Role"
                },
                organization: {
                    header: "Organization"
                },
                firstName: {
                    header: "First Name"
                },
                lastName: {
                    header: "Last Name"
                },
                email: {
                    header: "Email"
                },
                logInDate: {
                    header: "Log In Date"
                },
                lastAccessDate: {
                    header: "Last Access Date"
                }
            }
        },
        axnSessions: {
            columns: {
                transactionId: {
                    header: "Transaction ID"
                },
                mbun: {
                    header: "MBUN"
                },
                credential: {
                    header: "Credential"
                },
                apiKey: {
                    header: "API Key"
                },
                relyingParty: {
                    header: "Relying Party"
                },
                date: {
                    header: "Date"
                }
            }
        },
        dashboardVerificationServices: {
            title: "Recent Verification Service Changes",
            columns: {
                serviceName: {
                    header: "Service Name"
                },
                serviceType: {
                    header: "Service Type"
                },
                changeRequestStatus: {
                    header: "Change Request Status"
                },
                date: {
                    header: "Date"
                }
            }
        },
        dashboardVerificationTransactions: {
            title: "Recent Transactions",
            columns: {
                transactionId: {
                    header: "Transaction ID"
                },
                apiKey: {
                    header: "API Key"
                },
                credential: {
                    header: "Credential"
                },
                score: {
                    header: "Score"
                },
                policyDecision: {
                    header: "Policy Decision"
                }
            }
        },
        deployedPolicyComponents: {
            columns: {
                name: {
                    header: "Name"
                },
                class: {
                    header: "Class"
                },
                type: {
                    header: "Type"
                },
                organization: {
                    header: "Organization"
                },
                description: {
                    header: "Description"
                },
                status: {
                    header: "Status"
                }
            },
            dropdownItems: {
                open: {
                    label: "Open Policy Component Details"
                }
            }
        },
        fraudReport: {
            columns: {
                name: {
                    header: "Name"
                },
                claimStatus: {
                    header: "Claim Status"
                },
                riskLevel: {
                    header: "Risk Level"
                },
                decision: {
                    header: "Decision"
                },
                total: {
                    header: "Total"
                }
            }
        },
        identityProviders: {
            columns: {
                idpName: {
                    header: "IDP Name"
                },
                category: {
                    header: "Category"
                },
                organization: {
                    header: "Organization"
                },
                requestStatus: {
                    header: "Request Status"
                }
            },
            dropdownItems: {
                exportIDPConfiguration: {
                    label: "Export this IDP Configuration"
                },
                importIDPConfiguration: {
                    label: "Import an IDP Configuration"
                }
            }
        },
        messagingTemplates: {
            columns: {
                messagingTemplate: {
                    header: "Messaging Template"
                },
                name: {
                    header: "Template Name"
                },
                type: {
                    header: "Type"
                },
                organization: {
                    header: "Organization"
                },
                relyingParty: {
                    header: "Relying Party"
                },
                status: {
                    header: "Status"
                }
            },
            dropdownItems: {
                openDetails: {
                    label: "Open Messaging Template Details"
                }
            }
        },
        emailTemplates: {
            columns: {
                emailTemplate: {
                    header: "Email Template"
                },
                name: {
                    header: "Template Name"
                },
                organization: {
                    header: "Organization"
                },
                status: {
                    header: "Status"
                }
            },
            dropdownItems: {
                openDetails: {
                    label: "Open Email Template Details"
                }
            }
        },
        organizationInvitations: {
            columns: {
                organization: {
                    header: "Organization"
                },
                email: {
                    header: "Email"
                },
                role: {
                    header: "Role"
                },
                status: {
                    header: "Status"
                },
                created: {
                    header: "Created"
                },
                inviter: {
                    header: "Inviter"
                },
                relyingParty: {
                    header: "Relying Party"
                }
            },
            dropdownItems: {
                open: {
                    label: "Open Organization Invitation Details"
                }
            }
        },
        organizations: {
            columns: {
                name: {
                    header: "Name"
                },
                tier: {
                    header: "Tier"
                },
                code: {
                    header: "Code"
                },
                type: {
                    header: "Type"
                },
                status: {
                    header: "Status"
                }
            },
            dropdownItems: {
                open: {
                    label: "Open Organization Details"
                },
                archiveOrganization: {
                    label: "Archive Organization"
                },
                deleteOrganization: {
                    label: "Delete Organization"
                },
                restoreOrganization: {
                    label: "Restore Organization"
                },
            }
        },
        organizationUsers: {
            columns: {
                name: {
                    header: "Name"
                },
                roles: {
                    header: "Roles"
                },
                provider: {
                    header: "Provider"
                },
                organization: {
                    header: "Organization"
                },
                relyingParty: {
                    header: "Relying Party"
                },
                status: {
                    header: "Status"
                },
                created: {
                    header: "Created"
                }
            },
            dropdownItems: {
                inactivateUser: {
                    label: "Inactivate User"
                },
                restoreUser: {
                    label: "Restore User"
                },
                deleteUser: {
                    label: "Delete User"
                },
                open: {
                    label: "Open User Details"
                }
            }
        },
        refreshResults: {
            columns: {
                status: {
                    header: "Status"
                },
                message: {
                    header: "Message"
                }
            }
        },
        relyingParties: {
            columns: {
                name: {
                    header: "Name"
                },
                organization: {
                    header: "Organization"
                },
                axn: {
                    header: "AXN"
                },
                dcui: {
                    header: "DCUI"
                },
                axnui: {
                    header: "AXNUI"
                },
                kbaui: {
                    header: "KBAUI"
                },
                blockBuyCode: {
                    header: "Block Buy Code"
                },
                status: {
                    header: "Status"
                }
            },
            dropdownItems: {
                open: {
                    label: "Open Relying Party Details"
                },
                archiveRelyingParty: {
                    label: "Archive Relying Party"
                },
                deleteRelyingParty: {
                    label: "Delete Relying Party"
                },
                restoreRelyingParty: {
                    label: "Restore Relying Party",
                    disabledText: "You have reached the maximum number of relying parties allowed for your current subscription tier. To restore this relying party, please delete unused relying parties, upgrade your subscription, or contact support for further assistance."
                },
            }
        },
        securityRules: {
            columns: {
                id: {
                    header: "ID"
                },
                className: {
                    header: "Class Name"
                },
                pathText: {
                    header: "Path Text"
                },
                operationType: {
                    header: "Operation Type"
                },
                status: {
                    header: "Status"
                },
                ruleName: {
                    header: "Rule Name"
                }
            }
        },
        serviceAssertionPerformance: {
            columns: {
                assertionName: {
                    header: "Assertion Name"
                },
                service: {
                    header: "Service"
                },
                pass: {
                    header: "Pass %"
                },
                close: {
                    header: "Close %"
                },
                partial: {
                    header: "Partial %"
                },
                unverified: {
                    header: "Unverified %"
                },
                fail: {
                    header: "Fail %"
                },
                assertionScorePoints: {
                    header: "Assertion Score Points"
                },
                trustScorePenalty: {
                    header: "Trust Score Penalty"
                }
            }
        },
        serviceAssertionPerformanceComparison: {
            columns: {
                assertionPerformance: {
                    header: "Assertion Performance (%)"
                },
                benchmarkAssertionPerformance: {
                    header: "Benchmark Assertion Performance (%)"
                },
                assertionName: {
                    header: "Assertion Name"
                },
                service: {
                    header: "Service"
                },
                pass: {
                    header: "Pass"
                },
                close: {
                    header: "Close"
                },
                partial: {
                    header: "Partial"
                },
                unverified: {
                    header: "Unverified"
                },
                fail: {
                    header: "Fail"
                }
            }
        },
        serviceOfferingTransactionsSummary: {
            title: "Attribute Provider Transactions Summary",
            columns: {
                serviceOffering: {
                    header: "Attribute Provider"
                },
                totalTransactions: {
                    header: "Total Transactions"
                }
            }
        },
        serviceTemplates: {
            columns: {
                name: {
                    header: "Name"
                },
                id: {
                    header: "ID"
                }
            }
        },
        updateOrganizationUsers: {
            columns: {
                name: {
                    header: "Name"
                },
                email: {
                    header: "Email"
                },
                credential: {
                    header: "Credential"
                }
            }
        },
        userSummary: {
            title: "Monthly User Report",
            rows: {
                totalUniqueMonthlyUsers: {
                    label: "Total Unique Monthly Users"
                },
                approvedUsers: {
                    label: "Approved Users",
                    table: {
                        rows: {
                            newUsers: "New Users",
                            renewedUsers: "Renewed Users",
                            returningUsers: "Returning Users"
                        }
                    }
                },
                deniedUsers: {
                    label: "Denied Users"
                },
                otherUsers: {
                    label: "Other Users"
                }
            }
        },
        userTransactionsSummary: {
            title: "User Transactions Summary",
            columns: {
                count: {
                    header: "Count"
                },
                percent: {
                    header: "Percent"
                }
            },
            rows: {
                totalSessions: {
                    label: "Total Sessions"
                },
                approved: {
                    label: "Approved"
                },
                denied: {
                    label: "Denied"
                }
            }
        },
        verificationServices: {
            columns: {
                serviceName: {
                    header: "Service Name"
                },
                apiKey: {
                    header: "API Key"
                },
                relyingParty: {
                    header: "Relying Party"
                },
                workflow: {
                    header: "Workflow"
                },
                organizationName: {
                    header: "Organization Name"
                },
                serviceType: {
                    header: "Service Type"
                },
                crStatus: {
                    header: "CR Status"
                },
                lastDeployed: {
                    header: "Last Deployed"
                }
            },
            dropdownItems: {
                exportServiceConfiguration: {
                    label: "Export This Service Configuration"
                },
                importServiceConfiguration: {
                    label: "Import a Service Configuration"
                },
                archiveService: {
                    label: "Archive Service"
                },
                restoreService: {
                    label: "Restore Service"
                },
                deleteService: {
                    label: "Delete Service"
                }
            },
            tooltips: {
                lastModified: {
                    label: "Last Modified:"
                }
            }
        },
        verificationTransactionDetailsClaimsAssertions: {
            title: "Claims/Assertions",
            columns: {
                date: {
                    header: "Date"
                },
                verificationService: {
                    header: "Verification Service"
                },
                apiKey: {
                    header: "API Key"
                },
                serviceOffering: {
                    header: "Attribute Provider"
                },
                claim: {
                    header: "Claim"
                },
                claimStatus: {
                    header: "Claim Status"
                }
            }
        },
        verificationTransactionDetailsPolicyDecisions: {
            title: "Policy Decisions",
            columns: {
                date: {
                    header: "Date"
                },
                verificationService: {
                    header: "Verification Service"
                },
                apiKey: {
                    header: "API Key"
                },
                policy: {
                    header: "Policy"
                },
                decision: {
                    header: "Decision"
                },
                stepUpVerificationService: {
                    header: "Step Up Verification Service"
                },
                stepUpApiKey: {
                    header: "Step Up API Key"
                }
            }
        },
        verificationTransactionDetailsScoreComponents: {
            title: "Score Components",
            columns: {
                scoreAttribute: {
                    header: "Score Attribute"
                },
                normalizedScore: {
                    header: "Normalized Score"
                },
                details: {
                    header: "Details"
                }
            }
        },
        verificationTransactionDetailsScores: {
            title: "Scores",
            columns: {
                date: {
                    header: "Date"
                },
                scoreType: {
                    header: "Score Type"
                },
                score: {
                    header: "Score"
                },
                details: {
                    button: {
                        label: "Details"
                    }
                }
            }
        },
        verificationTransactionDetailsTransactionEvents: {
            title: "Transaction Events",
            columns: {
                date: {
                    header: "Date"
                },
                verificationService: {
                    header: "Verification Service"
                },
                apiKey: {
                    header: "API Key"
                },
                transactionEventDescription: {
                    header: "Transaction Event Description"
                },
                details: {
                    header: "Details"
                },
            }
        },
        verificationTransactionDetailsTrustScoreModifiers: {
            title: "Modifiers",
            columns: {
                assertion: {
                    header: "Assertion"
                },
                serviceOffering: {
                    header: "Attribute Provider"
                },
                status: {
                    header: "Status"
                },
                modifier: {
                    header: "Modifier"
                },
            }
        },
        verificationTransactions: {
            columns: {
                transactionId: {
                    header: "Transaction ID"
                },
                date: {
                    header: "Date"
                },
                relyingParty: {
                    header: "Relying Party"
                },
                verificationService: {
                    header: "Verification Service"
                },
                credential: {
                    header: "Credential"
                },
                score: {
                    header: "Score"
                },
                policyDecision: {
                    header: "Policy Decision"
                }
            }
        },
        workflowTemplates: {
            columns: {
                name: {
                    header: "Name"
                },
                id: {
                    header: "ID"
                },
                status: {
                    header: "Status"
                }
            }
        },
        workflows: {
            columns: {
                workflow: {
                    header: "Workflow"
                },
                organization: {
                    header: "Organization"
                },
                relyingParty: {
                    header: "Relying Party"
                },
                crStatus: {
                    header: "CR Status"
                },
                lastDeployed: {
                    header: "Last Deployed"
                }
            },
            dropdownItems: {
                archiveWorkflow: {
                    label: "Archive Workflow"
                },
                exportWorkflowConfiguration: {
                    label: "Export This Workflow Configuration"
                },
                restoreWorkflow: {
                    label: "Restore Workflow",
                    disabledText: "You have reached the maximum number of workflows allowed for your current subscription tier. To restore this workflow, please delete unused workflows, upgrade your subscription, or contact support for further assistance."
                },
                transactionReport: {
                    label: "Transaction Report"
                },
                workflowReport: {
                    label: "Workflow Report"
                },
                fraudReport: {
                    label: "Fraud Report"
                },
                manageServices: {
                    label: "Manage Services"
                },
                deleteWorkflow: {
                    label: "Delete Workflow"
                }
            },
            tooltips: {
                lastModified: {
                    label: "Last Modified:"
                }
            }
        }
    },
};